import * as echarts from 'echarts'
/* eslint-disable */
import Vue from 'vue'
import moment from 'moment'
const global_web_url_oss = "https://oss.tiantianhuoke.com"
export var vueThis = null
export function receiveNew(vm) {
  vueThis = vm
}
import {isEmpty} from '@/assets/diypaaspc/diy-pass-pc.js'
import {china_json} from '@/assets/diypaaspc/china_json.js'
import {mapdata} from '@/assets/diypaaspc/mapdata.js'
import qiunVueUcharts from '@qiun/vue-ucharts'
import RelationGraph from 'relation-graph'

var countDownFn = function (targetTime) {
  targetTime = targetTime.replaceAll('-', '/')
  var start = moment(new Date())
  var end = moment(new Date(targetTime))
  var diff = end.diff(start) < 0 ? 0 : end.diff(start)
  var time = {
    dd: moment.duration(diff).days(),
    hh: moment.duration(diff).hours(),
    mm: moment.duration(diff).minutes(),
    ss: moment.duration(diff).seconds(),
    run: diff > 0,
  }
  return time
}
function normalizeColor(color, alpha) {
  if (color.startsWith('rgba') || color.startsWith('rgb')) {
    // 如果是RGB或RGBA格式，则设置新的透明度
    const parseRgbaColor = (color) => {
      const arr = color.match(/(\d(\.\d+)?)+/g) || [];
      const res = arr.map((s) => parseInt(s, 10));
      return {
        r: res[0],
        g: res[1],
        b: res[2],
        a: parseFloat(arr[3]),
      }
    };
    const rgbaToHex =({r, g, b}) => {
      return "#" + [r, g, b].map(num => parseInt(num).toString(16).padStart(2, '0')).join('')
    }
    return rgbaToHex(parseRgbaColor(color));
  } else {
    // 如果是其他格式，保持原样
    return color;
  }
}
function guid(len = 32, firstU = true, radix = null) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  radix = radix || chars.length

  if (len) {
    // 如果指定uuid长度,只是取随机的字符,0|x为位运算,能去掉x的小数位,返回整数位
    for (var i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    var r
    // rfc4122标准要求返回的uuid中,某些位为固定的字符
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    for (var i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  // 移除第一个字符,并用u替代,因为第一个字符为数值时,该guuid不能用作id或者class
  if (firstU) {
    uuid.shift()
    return `u${uuid.join('')}`
  }
  return uuid.join('')
}
var themeColor = function (theme_color,type=1) {
  var themeColorList = []
  if (theme_color && theme_color.length > 0) {
    themeColorList = theme_color
  } else {
    themeColorList = vueThis.big_screen_color
  }
  if(type==2){
    themeColorList.map((item,index)=>{
      themeColorList[index] = normalizeColor(item)
    })
  }
  return themeColorList
}
var initAutoToolTip = function(chart, chartOption, options) {
  var defaultOptions = {
    interval: 2000,
    loopSeries: false,
    seriesIndex: 0,
    updateData: null
  };
  if (!chart || !chartOption) {
    return {};
  }
  var dataIndex = 0; // 数据索引，初始化为-1，是为了判断是否是第一次执行
  var seriesIndex = 0; // 系列索引
  var timeTicket = 0;
  var seriesLen = chartOption.series&&chartOption.series.length; // 系列个数
  var dataLen = 0; // 某个系列数据个数
  var chartType; // 系列类型
  var first = true;
  // 不循环series时seriesIndex指定显示tooltip的系列，不指定默认为0，指定多个则默认为第一个
  // 循环series时seriesIndex指定循环的series，不指定则从0开始循环所有series，指定单个则相当于不循环，指定多个
  // 要不要添加开始series索引和开始的data索引？
  if (options) {
    options.interval = options.interval || defaultOptions.interval;
    options.loopSeries = options.loopSeries || defaultOptions.loopSeries;
    options.seriesIndex = options.seriesIndex || defaultOptions.seriesIndex;
    options.updateData = options.updateData || defaultOptions.updateData;
  } else {
    options = defaultOptions;
  }
  // 如果设置的seriesIndex无效，则默认为0
  if (options.seriesIndex < 0 || options.seriesIndex >= seriesLen) {
    seriesIndex = 0;
  } else {
    seriesIndex = options.seriesIndex;
  }
  function autoShowTip() {
    function showTip() {
      // 判断是否更新数据
      if (dataIndex === 0 && !first && typeof options.updateData === "function") {
        options.updateData();
        chart.setOption(chartOption);
      }
      var series = chartOption.series;
      chartType = series[seriesIndex].type; // 系列类型
      dataLen = series[seriesIndex].data.length; // 某个系列的数据个数
      var tipParams = { seriesIndex: seriesIndex };
      switch (chartType) {
        case 'map':
        case 'pie':
        case 'chord':
          tipParams.name = series[seriesIndex].data[dataIndex].name;
          break;
        case 'radar': // 雷达图
          tipParams.seriesIndex = seriesIndex;
          tipParams.dataIndex = dataIndex;
          break;
        default:
          tipParams.dataIndex = dataIndex;
          break;
      }
      if (chartType === 'pie' || chartType === 'radar') {
        // 取消之前高亮的图形
        chart.dispatchAction({
          type: 'downplay',
          seriesIndex: options.loopSeries ? (seriesIndex === 0 ? seriesLen - 1 : seriesIndex - 1) : seriesIndex,
          dataIndex: dataIndex === 0 ? dataLen - 1 : dataIndex - 1
        });
        // 高亮当前图形
        chart.dispatchAction({
          type: 'highlight',
          seriesIndex: seriesIndex,
          dataIndex: dataIndex
        });
      }
      // 显示 tooltip
      tipParams.type = 'showTip';
      chart.dispatchAction(tipParams);
      dataIndex = (dataIndex + 1) % dataLen;
      if (options.loopSeries && dataIndex === 0 && !first) { // 数据索引归0表示当前系列数据已经循环完
        seriesIndex = (seriesIndex + 1) % seriesLen;
      }
      first = false;
    }
    showTip();
    timeTicket = setInterval(showTip, options.interval);
  }
  // 关闭轮播
  function stopAutoShow() {
    if (timeTicket) {
      clearInterval(timeTicket);
      timeTicket = 0;
      if (chartType === 'pie' || chartType === 'radar') {
        // 取消高亮的图形
        chart.dispatchAction({
          type: 'downplay',
          seriesIndex: options.loopSeries ? (seriesIndex === 0 ? seriesLen - 1 : seriesIndex - 1) : seriesIndex,
          dataIndex: dataIndex === 0 ? dataLen - 1 : dataIndex - 1
        });
      }
    }
  }
  var zRender = chart.getZr();
  function zRenderMouseMove(param) {
    if (param.event) {
      // 阻止canvas上的鼠标移动事件冒泡
      param.event.cancelBubble = true;
    }
    stopAutoShow();
  }
  // 离开echarts图时恢复自动轮播
  function zRenderGlobalOut() {
    if (!timeTicket) {
      autoShowTip();
    }
  }
  // 鼠标在echarts图上时停止轮播
  chart.on('mousemove', stopAutoShow);
  zRender.on('mousemove', zRenderMouseMove);
  zRender.on('globalout', zRenderGlobalOut);
  autoShowTip();
}
var seriesAssign = function (series,setting,linear_gradient_color,linear_idx=4,seriesData) {//linear_idx 横向柱状图第三位为1
  let arr= [];
  series.map((item,index) => {
    let color = null;let gradient_color= linear_gradient_color.length&&linear_gradient_color[index];
    function trans_gradient_color(linear_idx){
      return  {
        x: linear_idx==1?1:0,
        y: linear_idx==2?1:0,
        x2: linear_idx==3?1:0,
        y2: linear_idx==4?1:0,
        type: 'linear',
        global: false,
        colorStops: [
          {
            //第一节下面
            offset: parseFloat(gradient_color.start/100),
            color: gradient_color.color1,
          },
          {
            offset: 1,
            color: gradient_color.color2||gradient_color.color1
          },
        ],
      }
    }
    if(gradient_color&&!isEmpty(gradient_color.start)&&gradient_color.color1){
      color =  trans_gradient_color(linear_idx,gradient_color);
    }
    if(seriesData&&seriesData.seriesSetting&&item.type=='line'){
      item =  {
        ...item,
        ...setting,
        ...seriesData.seriesSetting,
        yAxisIndex:1
      }
    } else {
      item =  {
        ...item,
        ...(seriesData&&seriesData.seriesSetting||{}),
        ...setting,
        yAxisIndex:(seriesData&&seriesData.type=='line-double-y')?(index%2):0
      }
    }
    if(seriesData&&seriesData.type=='pie'){
      item.data.map((it,idx)=>{
        let gradient_color= linear_gradient_color.length&&linear_gradient_color[idx]
        if(gradient_color&&!isEmpty(gradient_color.start)&&gradient_color.color1){
          color =  trans_gradient_color(linear_idx,gradient_color);
        }
        let itemStyle
        if(item.itemStyle&&item.itemStyle.normal){
          itemStyle = {...item.itemStyle,normal: {...item.itemStyle.normal,color:color}}
        } else {
          itemStyle = {...item.itemStyle,normal: {...item.itemStyle,color:color}}
        }
        it.itemStyle = {...itemStyle}
      })
    } else {
      let gradient_color= linear_gradient_color.length&&linear_gradient_color[index]
      if(gradient_color&&!isEmpty(gradient_color.start)&&gradient_color.color1){
        color =  trans_gradient_color(linear_idx,gradient_color);
      }
      if(color){
        if(seriesData&&seriesData.type=='line-area-accumul'){
          item.areaStyle ={
            normal: {color:color}
          }
          let itemStyle ={}
          if(setting.itemStyle&&setting.itemStyle.length){
            itemStyle = setting.itemStyle[index%setting.itemStyle.length]
          } else {
            itemStyle = setting.itemStyle
          }
          if(!isEmpty(itemStyle)){
            item.itemStyle = itemStyle
          } else {
            delete item.itemStyle
          }
        } else if(item.itemStyle&&item.itemStyle.normal){
          let itemStyle = {...item.itemStyle,normal: {...item.itemStyle.normal,color:color}}
          item.itemStyle = {...itemStyle}
        } else {
          let itemStyle = {...item.itemStyle,normal: {...item.itemStyle,color:color}}
          item.itemStyle = {...itemStyle}
        }
      }
    }
    arr.push(item)
  })
  return arr
}
var arrRecombination = function(arr, n) {//一维数组转二维数组
  var arr2 = []
  if(arr&&arr.length){
    for (var i = 0, j = 0; i < arr.length; i += n) {
      // 初始化数组单个元素为数组
      arr2[j] = []
      for (var k = 0; k < n; k++) {
        if (i + k < arr.length) arr2[j].push(arr[i + k])
      }
      j++
    }
  }
  return arr2
}
var mixinsBaseProps = {
  template: `<div @click.self="handleClick" style="position: relative;"> 
  <div v-if="show_title=='true'" @click="handleClick" class="chart-title clickable-text"  :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{title_name  }}</div>
  <div :id="cId" :class="show_title=='true'?'chart-body':'chart-body-no-title'"></div>
  </div>`,
  data() {
    return {
      cId: guid(16),
      chart: null,
    }
  },
  props: {
    show_title: {
      type: String,
      default: "true",
    },
    title_position: {
      type: String,
      default: 'middle',
    },
    title_name: {
      type: String,
      default: '标题',
    },
    chart_show_type: {
      type: String,
      default: '',
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () => {},
    },
    data_source_field_name: {
      type: Object,
      default: () => {},
    },
    theme_color: {
      type: Array,
      default: () => [],
    },
    linear_gradient_color: {
      type: Array,
      default: () => [],
    },
    chartOption: {
      type: Object,
      default: () => {}
    },
    is_morcolor: {
      type: Boolean,
      default: false,
    },
    open_data_loop: {
      type: Boolean,
      default: false,
    },
    data_loop_num: {
      type: Number,
      default: 7,
    },
    data_loop_delay: {
      type: Number,
      default: 5,
    },
    label_limit:{
      type: Number,
      default: 0,
    }
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      immediate: true,
      deep: true,
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
  }
}
var mixinsResize = {
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.handleResize);
  },
  methods: {
    handleResize() {
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 500)
    },
  },
}
var mixinsPieEcharts = {
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.tooltip = this.chartOption.tooltip
        let series = seriesAssign( this.fieldOptions.series,{...this.chartOption.seriesSetting,...this.chartOption.labelSetting},this.linear_gradient_color,4,{type:'pie'})
        this.fieldOptions.series = series
        this.chart.setOption(this.fieldOptions);
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name.chart_data;
        this.commonInit(sourceData)
      }
    },
  },
}
var mixinsBarEcharts = {
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,2)
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
         initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
        }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
  },
}
var mixinsLineEcharts= {
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.seriesSetting,this.linear_gradient_color,this.linear_num,{type:this.chart_show_type,theme_color:themeColor(this.theme_color)})
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = (sourceData && sourceData.data) || [];
        this.commonInit(dataList, sourceData.xAxis);
      }
    },
  },
}
// 基础饼图
var benbenPieBase = {
  name: 'benben-pie-base',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    commonInit(sourceData) {
      if (sourceData && sourceData.length) {
        var dataOption = {
          legend: this.chartOption.legend,
          tooltip:this.chartOption.tooltip,
          series: [
            {
              type: 'pie',
              avoidLabelOverlap: false,
              ...this.chartOption.seriesSetting,
              ...this.chartOption.labelSetting,
              data: sourceData,
            },
          ],
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//普通圆环
var benbenPieRing = {
  name: 'benben-pie-ring',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    commonInit(sourceData) {
      if (sourceData) {
        var dataOption = {
          "tooltip": this.chartOption.tooltip,
          "legend": this.chartOption.legend,
          "series": [
            {
              "type": "pie",
              avoidLabelOverlap: false,
              ...this.chartOption.seriesSetting,
              ...this.chartOption.labelSetting,
              "data": sourceData
            }
          ]
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//圆角圆环
var benbenPieCircularRing = {
  name: 'benben-pie-circular-ring',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    commonInit(sourceData) {
      if (sourceData) {
        var dataOption = {
          "tooltip": this.chartOption.tooltip,
          "legend": this.chartOption.legend,
          "series": [
            {
              "name": "",
              "type": "pie",
              "avoidLabelOverlap": false,
              ...this.chartOption.seriesSetting,
              ...this.chartOption.labelSetting,
              "data": sourceData
            }
          ]
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//圆角饼图
var benbenPieCircular = {
  name: 'benben-pie-circular',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    commonInit(sourceData) {
      if (sourceData) {
        var dataOption = {
          legend: this.chartOption.legend,
          tooltip: this.chartOption.tooltip,
          "series": [
            {
              "type": "pie",
              ...this.chartOption.seriesSetting,
              ...this.chartOption.labelSetting,
              "data": sourceData
            }
          ]
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//玫瑰图
var benbenPieRose = {
  name: 'benben-pie-rose',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    commonInit(sourceData) {
      if (sourceData) {
        var dataOption = {
          legend: this.chartOption.legend,
          "tooltip": this.chartOption.tooltip,
          "series": [
            {
              "type": "pie",
              ...this.chartOption.seriesSetting,
              ...this.chartOption.labelSetting,
              "data": sourceData
            }
          ]
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//嵌套饼图
var benbenPieNestedRing = {
  name: 'benben-pie-nested-ring',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color);
        this.fieldOptions.legend = { ...this.fieldOptions.legend, ...this.chartOption.legend }
        var mergeProperties = {
          ...this.chartOption.seriesSetting,
        };
        this.fieldOptions.series[0] = {
          ...this.fieldOptions.series[0],
          ...mergeProperties,
          ...this.chartOption.innerSetting
        };
        this.fieldOptions.series[1] = {
          ...this.fieldOptions.series[1],
          ...mergeProperties,
          ...this.chartOption.outerSetting
        };
        var tooltip = {
          "tooltip": {
            "trigger": "item",
            "formatter": "{b}: {c} ({d}%)"
          }
        }
        this.fieldOptions.tooltip = tooltip;
        this.chart.setOption(this.fieldOptions);
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = sourceData && sourceData.data || [];
        if (dataList && dataList.length) {
          this.chartOption.legend.data = sourceData.legend;
          var mergeProperties = {
            ...this.chartOption.seriesSetting,
          };
          var dataOption = {
            "tooltip": {
              "trigger": "item",
              "formatter": "{b}: {c} ({d}%)"
            },
            "legend": this.chartOption.legend,
            "series": [
              {
                "data": dataList[0].data,
                ...mergeProperties,
                ...this.chartOption.innerSetting
              },
              {
                "data": dataList[1].data,
                ...mergeProperties,
                ...this.chartOption.outerSetting
              }
            ]
          }
          dataOption.color = themeColor(this.theme_color);
          this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        }
      }
    }
  },
}
//圆环进度条
var benbenPieProgress = {
  name: 'benben-pie-progress',
  mixins:[mixinsBaseProps,mixinsResize,mixinsPieEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        var copyChartOption = this.chartOption.progressSetting;
        copyChartOption.data[0].value = this.fieldOptions.data.value
        copyChartOption.data[0].name = this.fieldOptions.data.name
        this.chart.setOption({ series: [{ ...copyChartOption }] });
      } else if (this.data_source_type == '2') {
        var chart_data = this.data_source_field_name.chart_data;
        if (chart_data) {
          var dataOption = this.chartOption.progressSetting
          dataOption.data[0].value = chart_data.value;
          if (chart_data.name) {
            dataOption.data[0].name = chart_data.name
          }
          var resultOption = { series: [{ ...dataOption }] }
          this.chart.setOption(resultOption);
        }
      }
    },
  },
}
// 旋转圆环
var benbenRotateRing = {
  template: `
  <div id="app" class="ring-box" @click.self="handleClick">
  <div class="canvas-box">
    <canvas ref="outside" width="400" height="400" class="outside"></canvas>
    <canvas ref="internal" width="400" height="400" class="internal"></canvas>
  </div>
  <div class="ring-legend">
    <span @click="item.isShow=!item.isShow" v-for="(item,i) in angleList"
      :style="{color:item.isShow?item.color:'#eee'}" :key="i">
      <i :style="{'background-color': item.isShow?item.color:'#eee'}"></i>
      {{item[nameKey]}}
    </span>
  </div>
</div>
  `,
  name: 'benben-rotate-ring',
  data() {
    return {
      angleList: [],
      themeColor: "rgba(255,255,255,0.2)",
      nameKey: "name",
      valueKey: "value",
    }
  },
   mixins:[mixinsBaseProps],
  watch: {
    angleList: {
      deep: true,
      immediate: true,
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(this.init);
        }
      },
    }
  },
  methods: {
    renderChart() {
      if (this.data_source_type == '1') {
        this.dataInfo = this.fieldOptions.series[0]['data']
      } else if (this.data_source_type == '2') {
        this.dataInfo = this.data_source_field_name.chart_data;
      }
      if (!isEmpty(this.dataInfo)){
        this.angleList = this.getAngleList();
      }
    },
    rawAngle(data) {
      //先获取数据的总和
      var total = data.reduce((accumulator, currentValue) => {
        return +currentValue[this.valueKey] + accumulator;
      }, 0);
      //获取每条数据的弧度
      return data
        .map((item, index) => {
          var angle = (item[this.valueKey] / total) * Math.PI * 2;
          return { ...item, angle,
            color: item.isShow ? item.color : this.themeColor,
            width: item[this.valueKey] / total + 0.6,
          };
        })
        .filter((item) => item[this.valueKey]);
    },
    getAngleList() {
      //先获取数据的总和
      let colorIndex = 0;
      //获取每条数据的弧度
      return this.dataInfo.map((item, index) => {
        let color = themeColor(this.theme_color)[colorIndex];
        if (themeColor(this.theme_color)[colorIndex + 1]){ colorIndex++;
        } else {colorIndex = 0;}
        return {...item, color, isShow: true, };
      });
    },
    init() {
      let angleList = this.rawAngle(this.angleList);
      let canvas = this.$refs.outside;
      let internalCanvas = this.$refs.internal;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let x0 = canvas.width / 2;
      let y0 = canvas.height / 2;
      let radius = canvas.width / 2 - 60;
      var start = 0; //起始弧度
      let internalCtx = internalCanvas.getContext("2d");
      internalCtx.clearRect( 0,0,internalCanvas.width,internalCanvas.height);
      let internalX0 = internalCanvas.width / 2;
      let internalY0 = internalCanvas.height / 2;
      let internalRadius = internalCanvas.width / 2 - 30;
      let internalStart = 0;
      ctx.beginPath();
      ctx.arc(x0, y0, canvas.width / 2 - 10, 0, 2 * Math.PI);
      ctx.strokeStyle = this.themeColor;
      ctx.lineWidth = 4;
      ctx.stroke();
      internalCtx.beginPath();
      internalCtx.arc(x0,y0,internalCanvas.width / 2 - 60,0,2 * Math.PI);
      internalCtx.strokeStyle = this.themeColor;
      internalCtx.lineWidth = 120;
      internalCtx.stroke();
      angleList.forEach((item, i) => {
        var end = item.angle + start;
        ctx.beginPath();
        ctx.arc(x0, y0, radius,start + item.angle / 14 / item.width, end - item.angle / 14 / item.width);
        ctx.strokeStyle = item.color;
        ctx.lineWidth = item.width * 20;
        ctx.lineCap = "round";
        ctx.stroke();
        start = end;
        var internalEnd = item.angle + internalStart;
        internalCtx.beginPath();
        internalCtx.arc(internalX0,internalY0, internalRadius,internalStart,internalEnd);
        internalCtx.lineWidth = 20;
        let startX = internalX0 + internalRadius * Math.cos(internalStart);
        let startY = internalY0 + internalRadius * Math.sin(internalStart);
        let endX = internalX0 + internalRadius * Math.cos(internalEnd);
        let endY = internalY0 + internalRadius * Math.sin(internalEnd);
        if ( Math.round(startX) == Math.round(endX) && Math.round(startY) == Math.round(endY)) {
          internalCtx.strokeStyle = item.color;
        } else {
          var g = internalCtx.createLinearGradient( startX, startY, endX, endY); //创建渐变对象  渐变开始点和渐变结束点
          g.addColorStop(0, item.color); //添加颜色点
          g.addColorStop(1, "rgba(255,255,255,0)"); //添加颜色点
          internalCtx.strokeStyle = g;
        }
        internalCtx.lineWidth = 15;
        internalCtx.stroke();
        internalStart = internalEnd;
      });
    },
  },
}
//堆积柱状图
var benbenBarAccumul = {
  name: 'benben-bar-accumul',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    commonInit(dataList, xAxis) {
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        xAxis: {...this.chartOption.xAxis,data:xAxis},
        yAxis: this.chartOption.yAxis,
          stack: this.title_name,
          series: seriesAssign(dataList,{stack: this.title_name,...this.chartOption.barSetting},this.linear_gradient_color,2)
      }
      dataOption.color = themeColor(this.theme_color)
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
        initAutoToolTip(this.chart,dataOption,{loopSeries: true })
      }
    },
  },
}
//柱状图
var benbenBarBase = {
  name: 'benben-bar-base',
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      }
    }
  },
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    commonInit(dataList, xAxis) {
      dataList.forEach((item, idx) => {
        dataList[idx] = { ...item, ...this.chartOption.barSetting}
      })
      var that = this
      if(this.open_data_loop){
        if (that.chart_timer_config.timer) {
          clearInterval(that.chart_timer_config.timer);
          that.chart_timer_config.timer = null;
        }
        that.chart_timer_config.currentIndex = 0;
        that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
        that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
        dataList.map((item,idx)=>{
          let arrItem =mixinCopyData(item);
          arrItem.data = arrRecombination(item.data,that.data_loop_num);
          that.chart_timer_config.data[idx] = arrItem;
        });
        setTimeout(() => {
          that.chart_timer_config.timer = setInterval(function () {
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis);
          }, that.data_loop_delay*1000)
          if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
            that.chart_timer_config.currentIndex = 0;
          } else {
            that.chart_timer_config.currentIndex += 1;
          }
          dataList.map((item,idx)=>{
            item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
            dataList[idx] = item;
          });
          xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
          that.loop_init(dataList, xAxis);
        })
      } else {
        that.loop_init(dataList, xAxis);
      }
    },
    loop_init(dataList, xAxis){
      if (dataList && dataList.length) {
        dataList.forEach((item, idx) => {
          dataList[idx] = { ...item, ...this.chartOption.barSetting}
        })
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis: {...this.chartOption.xAxis,data:xAxis},
          yAxis: this.chartOption.yAxis,
          series: seriesAssign(dataList,this.chartOption.barSetting,this.linear_gradient_color,2)
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(!this.open_data_loop&&this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true });
         }
      }
    }
  },
}
//象形柱图
var benbenBarPictorial = {
  name: 'benben-bar-pictorial',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis: {...this.chartOption.xAxis,data:xAxis},
          yAxis: this.chartOption.yAxis,
          series: seriesAssign(dataList,{type:"pictorialBar", ...this.chartOption.barSetting},this.linear_gradient_color,2)
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//横向象形柱图
var benbenBarPictorialCross = {
  name: 'benben-bar-pictorial-cross',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'});
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.yAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.yAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = []
        this.chartOption.barSetting.map((item,index)=>{
          (item =  { ...item,...this.fieldOptions.series[0] })
          series[index] = item
        })
        series = seriesAssign(series,{},this.linear_gradient_color,2)
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
         initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
        }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        let series = []
        this.chartOption.barSetting.map((item,index)=>{
          (item =  {
            ...item,
          ...dataList[0]
          })
          series[index] = item
        })
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          yAxis: {...this.chartOption.yAxis,data:xAxis},
          xAxis: this.chartOption.xAxis,
          series: seriesAssign(series,{},this.linear_gradient_color,2)
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//横向柱图
var benbenBarCross = {
  name: 'benben-bar-cross',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      }
    }
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      var that = this;
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.yAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.yAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,3)
        if(this.is_morcolor){
          series.forEach(item => {
            item.itemStyle = {
              ...item.itemStyle,
              color: function (params) {
                var num = themeColor(that.theme_color).length;
                return themeColor(that.theme_color)[params.dataIndex % num];
              }
            }
          })
        }
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis) {
      if(this.is_reverse){
        dataList.map((item,idx)=>{
          item.data = item.data.reverse();
          dataList[idx] = item;
        });
        xAxis = xAxis.reverse();
      }
      var that = this
      if(this.open_data_loop){
        if (that.chart_timer_config.timer) {
          clearInterval(that.chart_timer_config.timer)
          that.chart_timer_config.timer = null
        }
        that.chart_timer_config.currentIndex = -1;
        that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
        that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
        dataList.map((item,idx)=>{
          let arrItem =mixinCopyData(item);
          arrItem.data = arrRecombination(item.data,that.data_loop_num);
          that.chart_timer_config.data[idx] = arrItem;
        });
        setTimeout(() => {
          that.chart_timer_config.timer = setInterval(function () {
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis);
          }, that.data_loop_delay*1000)
          if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
            that.chart_timer_config.currentIndex = 0;
          } else {
            that.chart_timer_config.currentIndex += 1;
          }
          dataList.map((item,idx)=>{
            item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
            dataList[idx] = item;
          });
          xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
          that.loop_init(dataList, xAxis);
        })
      } else {
        that.loop_init(dataList, xAxis);
      }
    },
    loop_init(dataList, xAxis){
      var that = this;
      if (dataList && dataList.length) {
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          yAxis: {...this.chartOption.yAxis,data:xAxis},
          xAxis: this.chartOption.xAxis,
          series: seriesAssign(dataList,this.chartOption.barSetting,this.linear_gradient_color,3)
        }
        if(this.is_morcolor){
          dataOption.series.forEach(item => {
            item.itemStyle = {
              ...item.itemStyle,
              color: function (params) {
                var num = themeColor(that.theme_color).length;
                return themeColor(that.theme_color)[params.dataIndex % num];
              }
            }
          })
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(!this.open_data_loop&&this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true });
         }
      }
    }
  },
}
//多系列柱图
var benbenBarMultiSeries = {
  name: 'benben-bar-multi-series',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'});
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,2)
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis);
        }
      }
    },
    commonInit(dataList, xAxis) {
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        xAxis:[{ data:xAxis,...this.chartOption.xAxis}],
        yAxis: [this.chartOption.yAxis],
        series: seriesAssign(dataList,this.chartOption.barSetting,this.linear_gradient_color,2)
      }
      dataOption.color = themeColor(this.theme_color)
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
        initAutoToolTip(this.chart,dataOption,{loopSeries: true })
       }
    },
  },
}
//正负柱图
var benbenBarPlusMinus = {
  name: 'benben-bar-plus-minus',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'});
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.yAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.yAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,3)
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis) {
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        yAxis: {...this.chartOption.yAxis,data:xAxis},
        xAxis: this.chartOption.xAxis,
        series: seriesAssign(dataList,this.chartOption.barSetting,this.linear_gradient_color,3)
      }
      dataOption.color = themeColor(this.theme_color)
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
        initAutoToolTip(this.chart,dataOption,{loopSeries: true })
       }
    },
  },
}
//正负背景柱状图
var benbenBarBackground = {
  name: 'benben-bar-background',
  mixins:[mixinsBaseProps,mixinsResize,mixinsBarEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'});
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = {...this.fieldOptions.yAxis,...this.chartOption.yAxis}
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,2)
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis) {
      dataList.forEach((item, idx) => {
        dataList[idx] = {
          ...item,
          ...this.chartOption.barSetting,
        }
      })
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        yAxis: {...this.chartOption.yAxis},
        xAxis: {...this.chartOption.xAxis,data:xAxis},
        series: seriesAssign(dataList,this.chartOption.barSetting,this.linear_gradient_color,2)
      }
      dataOption.color = themeColor(this.theme_color)
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
        initAutoToolTip(this.chart,dataOption,{loopSeries: true })
       }
    },
  },
}
// 区域堆积折线图
var benbenLineAreaAccumul = {
  name: 'benben-line-area-accumul',
  mixins:[mixinsBaseProps,mixinsResize,mixinsLineEcharts],
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      },
      linear_num:2
    }
  },
  methods: {
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        var that = this;
        if(this.open_data_loop){
          if (that.chart_timer_config.timer) {
            clearInterval(that.chart_timer_config.timer);
            that.chart_timer_config.timer = null;
          }
          that.chart_timer_config.currentIndex = -1;
          that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
          that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
          dataList.map((item,idx)=>{
            let arrItem =mixinCopyData(item);
            arrItem.data = arrRecombination(item.data,that.data_loop_num);
            that.chart_timer_config.data[idx] = arrItem;
          });
          setTimeout(() => {
            that.chart_timer_config.timer = setInterval(function () {
              if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
                that.chart_timer_config.currentIndex = 0;
              } else {
                that.chart_timer_config.currentIndex += 1;
              }
              dataList.map((item,idx)=>{
                item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
                dataList[idx] = item;
              });
              xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
              that.loop_init(dataList, xAxis);
            }, that.data_loop_delay*1000)
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis);
          })
        } else {
          that.loop_init(dataList, xAxis);
        }
      }
    },
    loop_init(dataList, xAxis){
      if (dataList && dataList.length) {
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis:[{ data:xAxis,...this.chartOption.xAxis}],
          yAxis: [this.chartOption.yAxis],
          series: seriesAssign(dataList,{...this.chartOption.seriesSetting,type:'line'},this.linear_gradient_color,this.linear_num,{type:"line-area-accumul",theme_color:themeColor(this.theme_color)})
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(!this.open_data_loop&&this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true });
         }
      }
    }
  },
}
//双Y轴折线
var benbenLineDoubleY = {
  name: 'benben-line-double-y',
  mixins:[mixinsBaseProps,mixinsResize,mixinsLineEcharts],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'});
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = this.chartOption.yAxis
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.seriesSetting,this.linear_gradient_color,2,{type:'line-double-y'})
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        var dataList = (sourceData && sourceData.data) || []
        this.commonInit(dataList, sourceData.xAxis)
      }
    },
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        var yAxis = []
        var series = []
        dataList.forEach((item, idx) => {
          var yObj = {
            type: 'value',
            name: item.name,
            position: idx == 0 ? 'right' : 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#6E7079',
              },
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff',
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#6E7079'],
              },
            },
          }
          yAxis.push(yObj)
          var seriesObj = {
            yAxisIndex: idx,
            ...item,
          }
          series.push(seriesObj)
        })
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis: [
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                formatter: '{value}',
                color: '#fff',
              },
              data: xAxis,
              ...this.chartOption.xAxis,
            },
          ],
          yAxis: yAxis,
          series: seriesAssign(dataList,{...this.chartOption.barSetting,type:'line'},this.linear_gradient_color,2,{type:'line-double-y'})
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
         }
      }
    },
  },
}
//标点折线
var benbenLineFold = {
  name: 'benben-line-fold',
  mixins:[mixinsBaseProps,mixinsResize,mixinsLineEcharts],
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      },
      linear_num:2
    }
  },
  methods: {
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        var that = this
        if(this.open_data_loop){
          if (that.chart_timer_config.timer) {
            clearInterval(that.chart_timer_config.timer);
            that.chart_timer_config.timer = null;
          }
          that.chart_timer_config.currentIndex = -1;
          that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
          that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
          dataList.map((item,idx)=>{
            let arrItem =mixinCopyData(item);
            arrItem.data = arrRecombination(item.data,that.data_loop_num);
            that.chart_timer_config.data[idx] = arrItem;
          });
          setTimeout(() => {
            that.chart_timer_config.timer = setInterval(function () {
              if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
                that.chart_timer_config.currentIndex = 0;
              } else {
                that.chart_timer_config.currentIndex += 1;
              }
              dataList.map((item,idx)=>{
                item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
                dataList[idx] = item;
              });
              xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
              that.loop_init(dataList, xAxis);
            }, that.data_loop_delay*1000)
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis);
          })
        } else {
          that.loop_init(dataList, xAxis);
        }
      }
    },
    loop_init(dataList, xAxis){
      if (dataList && dataList.length) {
        dataList.forEach((item, idx) => {
          dataList[idx] = { ...item, symbol: "circle", symbolSize: 8 }
        });
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis:[{ data:xAxis,...this.chartOption.xAxis}],
          yAxis: [this.chartOption.yAxis],
          series: seriesAssign(dataList,{...this.chartOption.seriesSetting,type:'line'},this.linear_gradient_color,this.linear_num)
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']});
        if(!this.open_data_loop&&this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true });
         }
      }
    }
  },
}
//线柱混搭
var benbenLineMatchBar = {
  name: 'benben-line-match-bar',
  mixins:[mixinsBaseProps,mixinsResize,mixinsLineEcharts],
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      },
      linear_num:2
    }
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if(this.label_limit&&this.label_limit>0){
        var label_limit = this.label_limit;
        var optionsAxis = this.chartOption.xAxis;
        optionsAxis.axisLabel = {
          ...optionsAxis.axisLabel,
          formatter: function (value, index) {
            return value.length>label_limit ?value.slice(0,label_limit):value;
          },
        }
        this.chartOption.xAxis = optionsAxis
      }
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.grid = this.chartOption.grid
        this.fieldOptions.xAxis = {...this.fieldOptions.xAxis,...this.chartOption.xAxis}
        this.fieldOptions.yAxis = this.chartOption.yAxis
        let series = seriesAssign(this.fieldOptions.series,this.chartOption.barSetting,this.linear_gradient_color,2,{seriesSetting:this.chartOption.seriesSetting||{},type:'line-match-bar'})
        this.$set(this.fieldOptions,'series',series)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
        }
      }  else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis,yAxis) {
      var that = this
      if(this.open_data_loop){
        if (that.chart_timer_config.timer) {
          clearInterval(that.chart_timer_config.timer);
          that.chart_timer_config.timer = null;
        }
        that.chart_timer_config.currentIndex = -1;
        that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
        that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
        dataList.map((item,idx)=>{
          let arrItem =mixinCopyData(item);
          arrItem.data = arrRecombination(item.data,that.data_loop_num);
          that.chart_timer_config.data[idx] = arrItem;
        });
        setTimeout(() => {
          that.chart_timer_config.timer = setInterval(function () {
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis,yAxis);
          }, that.data_loop_delay*1000)
          if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
            that.chart_timer_config.currentIndex = 0;
          } else {
            that.chart_timer_config.currentIndex += 1;
          }
          dataList.map((item,idx)=>{
            item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
            dataList[idx] = item;
          });
          xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
          that.loop_init(dataList, xAxis,yAxis);
        })
      } else {
        that.loop_init(dataList, xAxis,yAxis);
      }
    },
    loop_init(dataList, xAxis,dyAxis){
      var yAxis = []
      var series = []
      if (dataList.length > 0) {
        for (var index = 0; index < dataList.length; index++) {
          var dataMap = dataList[index];
          var yAxisDic = {
            type: 'value',
            name: dataMap.name,
            alignTicks: true,
            ...this.chartOption.yAxis[(index)%2],
          }
          yAxis.push(yAxisDic)
          var seriesDic = {
            name: dataMap.name,
            type: dataMap.type,
            yAxisIndex: index,
            data: dataMap.data,
          }
          if (dataMap.type == 'bar') {
            seriesDic.itemStyle = { borderRadius: [5, 5, 5, 5] }
            seriesDic = { ...seriesDic, ...this.chartOption.barSetting }
          } else if (dataMap.type == 'line') {
            seriesDic = { ...seriesDic}
          }
          series.push(seriesDic)
        }
      }
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
            data: xAxis,
            ...this.chartOption.xAxis,
          },
        ],
        yAxis: yAxis,
        series: series,
      }
      dataOption.color = themeColor(this.theme_color)
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
        initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
      }
    }
  },
}
//基础折线
var benbenLineSimple = {
  name: 'benben-line-simple',
  mixins:[mixinsBaseProps,mixinsResize,mixinsLineEcharts],
  data(){
    return {
      chart_timer_config:{
        timer:null,
        categories:[],
        data:[],
        currentIndex:-1,
        size:1
      },
      linear_num:2
    }
  },
  methods: {
    commonInit(dataList, xAxis) {
      if (dataList && dataList.length) {
        var that = this
        if(this.open_data_loop){
          if (that.chart_timer_config.timer) {
            clearInterval(that.chart_timer_config.timer);
            that.chart_timer_config.timer = null;
          }
          that.chart_timer_config.currentIndex = -1;
          that.chart_timer_config.size = (xAxis.length)/that.data_loop_num;
          that.chart_timer_config.categories = arrRecombination(xAxis,that.data_loop_num);
          dataList.map((item,idx)=>{
            let arrItem =mixinCopyData(item);
            arrItem.data = arrRecombination(item.data,that.data_loop_num);
            that.chart_timer_config.data[idx] = arrItem;
          });
          setTimeout(() => {
            that.chart_timer_config.timer = setInterval(function () {
              if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
                that.chart_timer_config.currentIndex = 0;
              } else {
                that.chart_timer_config.currentIndex += 1;
              }
              dataList.map((item,idx)=>{
                item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
                dataList[idx] = item;
              });
              xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
              that.loop_init(dataList, xAxis);
            }, that.data_loop_delay*1000)
            if(that.chart_timer_config.currentIndex + 1>=that.chart_timer_config.size){
              that.chart_timer_config.currentIndex = 0;
            } else {
              that.chart_timer_config.currentIndex += 1;
            }
            dataList.map((item,idx)=>{
              item.data = that.chart_timer_config.data[idx].data[that.chart_timer_config.currentIndex];
              dataList[idx] = item;
            });
            xAxis= that.chart_timer_config.categories[that.chart_timer_config.currentIndex];
            that.loop_init(dataList, xAxis);
          })
        } else {
          that.loop_init(dataList, xAxis);
        }
      }
    },
    loop_init(dataList, xAxis){
      if (dataList && dataList.length) {
        var dataOption = {
          tooltip: this.chartOption.tooltip,
          legend: this.chartOption.legend,
          grid: this.chartOption.grid,
          xAxis:[{ data:xAxis,...this.chartOption.xAxis}],
          yAxis: [this.chartOption.yAxis],
          series: seriesAssign(dataList,{...this.chartOption.seriesSetting},this.linear_gradient_color,2)
        }
        dataOption.color = themeColor(this.theme_color);
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(!this.open_data_loop&&this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true });
         }
      }
    }
  },
}
// 雷达
var benbenOtherRadar = {
  name: 'benben-other-radar',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      let lineSettingConfig = {
        "axisLine": {
            "show": this.chartOption.radarSetting.axisLine?this.chartOption.radarSetting.axisLine.show:true,
            "lineStyle": {
                "color": this.chartOption.radarSetting.axisLine?this.chartOption.radarSetting.axisLine.lineStyle.color:"rgba(231, 234, 239, 1)",
                "type":this.chartOption.radarSetting.isdash?"dashed":"solid"
            }
        },
        "splitLine": {
            "show": this.chartOption.radarSetting.splitLine?this.chartOption.radarSetting.splitLine.show:true,
            "lineStyle": {
                "color": this.chartOption.radarSetting.axisLine?this.chartOption.radarSetting.splitLine.lineStyle.color:"rgba(231, 234, 239, 1)",
                "type":this.chartOption.radarSetting.isdash?"dashed":"solid"
            }
        },
      }
      this.fieldOptions.tooltip = {...this.chartOption.tooltip,position: 'inside',trigger: 'item'};
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.legend = this.chartOption.legend;
        this.fieldOptions.radar = {
          ...this.fieldOptions.radar,
          ...this.chartOption.radarSetting,
          ...lineSettingConfig
        }
        this.fieldOptions.radar.indicator.map((item,index)=>{
          item.color = this.chartOption.radarSetting.indicatorColor;
        })
        this.fieldOptions.series[0].data = this.set_gradient_color(this.fieldOptions.series[0].data)
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        if (sourceData.data && sourceData.data.length) {
          sourceData.radar.forEach((item) => {
            item.color = this.chartOption.radarSetting.indicatorColor
          })
          sourceData.data.forEach((item) => {
            item.value = item.data
          })
          sourceData.data=  this.set_gradient_color(sourceData.data)
          var dataOption = {
            legend: this.chartOption.legend,
            tooltip:this.fieldOptions.tooltip,
            radar: {
              indicator: sourceData.radar,
              ...this.chartOption.radarSetting,
              ...lineSettingConfig,
              shape: !this.chartOption.radarSetting.isDrawCircle ? 'polygon' : 'circle'
            },
            series: [
              {
                type: 'radar',
                data: sourceData.data,
              },
            ],
          }
          dataOption.color = themeColor(this.theme_color)
          this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
          if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
            initAutoToolTip(this.chart,dataOption,{loopSeries: true })
           }
        }
      }
    },
    set_gradient_color(arr){
      let linear_gradient_color = this.linear_gradient_color
      if(!linear_gradient_color.length) return arr
      arr.map((item,index)=>{
          let color = null;let gradient_color= linear_gradient_color.length&&linear_gradient_color[index%linear_gradient_color.length]
          if(gradient_color&&!isEmpty(gradient_color.start)&&gradient_color.color1){
            color =  new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: parseFloat(gradient_color.start/100),
              color: gradient_color.color1
          }, {
              offset: 1,
              color: gradient_color.color2||gradient_color.color1
          }])
          }
          color&&(arr[index]={...item, areaStyle: {
            // 内网颜色
            normal: {
                color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: parseFloat(gradient_color.start/100),
                  color: gradient_color.color1
              }, {
                  offset: 1,
                  color: gradient_color.color2||gradient_color.color1
              }]),
                opacity: 1,
            }
        },})
      })
      return arr
    }
  },
}
// 漏斗
var benbenOtherFunnel = {
  name: 'benben-other-funnel',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        this.fieldOptions.legend = this.chartOption.legend
        this.fieldOptions.tooltip = this.chartOption.tooltip
        this.fieldOptions.series[0] = {
          ...this.fieldOptions.series[0],
          ...this.chartOption.labelSetting,
          ...this.chartOption.seriesSetting
        }
        this.chart.setOption(this.fieldOptions)
        if(this.chartOption.tooltip&&this.chartOption.tooltip.show&&this.chartOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,this.fieldOptions,{loopSeries: true })
         }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name.chart_data || []
        this.commonInit(sourceData)
      }
    },
    commonInit(sourceData) {
      if (sourceData && sourceData.length) {
        var dataOption = {
          legend: this.chartOption.legend,
          tooltip: this.chartOption.tooltip,
          series: [
            {
              name: '漏斗图',
              type: 'funnel',
              width: '60%',
              height: '80%',
              left: '20%',
              ...this.chartOption.labelSetting,
              ...this.chartOption.seriesSetting,
              data: sourceData,
            },
          ],
        }
        dataOption.color = themeColor(this.theme_color)
        this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
        if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
          initAutoToolTip(this.chart,dataOption,{loopSeries: true })
        }
      }
    },
  },
}
// 仪表盘
var benbenOtherDashboard = {
  name: 'benben-other-dashboard',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.fieldOptions.color = themeColor(this.theme_color)
        var fieldOptions = mixinCopyData(this.fieldOptions)
        if (fieldOptions.series[0]['axisLine']) {
          var colorList = fieldOptions.series[0]['axisLine'].lineStyle.color
          if (colorList && colorList.length) {
            colorList.map((item, idx) => {
              item[1] = themeColor(this.theme_color)[idx]
              return item
            })
          }
          fieldOptions.series[0]['axisLine'] = {
            lineStyle: {
              width: fieldOptions.series[0]['axisLine'].lineStyle.width || 10,
              color: fieldOptions.series[0]['axisLine'].lineStyle.color,
            },
          }
        } else {
          fieldOptions.series[0]['axisLine'] = {
            lineStyle: {
              width: 10,
              color: [
                [0.3, themeColor(this.theme_color)[0]],
                [0.7, themeColor(this.theme_color)[1]],
                [1, themeColor(this.theme_color)[2]],
              ],
            },
          }
        }
        this.chart.setOption(fieldOptions)
      } else if (this.data_source_type == '2') {
        var chart_data = this.data_source_field_name.chart_data
        if (chart_data) {
          var dataOption = {
            type: 'gauge',
            pointer: {
              itemStyle: { color: 'auto',},
            },
            "title": { "show": true, "x": "50%", "y": "25%", "z": 8, "textAlign": "center", "textStyle": { "color": "inherit", "fontSize": 18, "fontWeight": "normal" } },
            "axisTick": {
              "distance": -10, "length": 8,
              "lineStyle": { "color": "#fff", "width": 2 }
            },
            "splitLine": { "distance": 0, "length": 10, "lineStyle": { "color": "#fff", "width": 1 } },
            "axisLabel": { "color": "inherit", "distance": 20, "fontSize": 14 },
            "detail": {
              "valueAnimation": true, "formatter": "{value}",
              "color": "inherit"
            }
            , data: [
              {
                value: 0,
              },
            ],
          }
          dataOption.data[0].value = chart_data.value
          if (chart_data.name) {
            dataOption.data[0].name = chart_data.name
          }
          var axisLine = {
            lineStyle: {
              width: 10,
              color: [
                [0.3, themeColor(this.theme_color)[0]],
                [0.7, themeColor(this.theme_color)[1]],
                [1, themeColor(this.theme_color)[2]],
              ],
            },
          }
          var resultOption = { series: [{ ...dataOption, axisLine }] }
          resultOption.color = themeColor(this.theme_color)
          this.chart.setOption(resultOption)
        }
      }
    },
  },
}
// 地图
var benbenChinaMap = {
  name: 'benben-china-map',
  mixins:[mixinsBaseProps,mixinsResize],
  watch: {
    chartOption: {
      handler(newValue, oldval) {
        if (newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
  },
  mounted() {
    var that = this
    that.renderChart();
    window.addEventListener('resize', that.handleResize);
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      echarts.registerMap('china', china_json)
      if (this.data_source_type == '1') {
        var sourceData = this.fieldOptions.sourceData
        var targetData = this.fieldOptions.targetData
        this.commonInit(sourceData,targetData);
      }else if(this.data_source_type == '2'){
        var paramData = this.data_source_field_name
        if (paramData) {
          this.commonInit(paramData.sourceData, paramData.targetData);
        }
      }
    },
    commonInit(sourceData,targetData) {
        var convertData = function (data, targetData) {
          var res = []
          for (var i = 0; i < data.length; i++) {
            var dataItem = data[i]
            res.push({
              fromName: dataItem.name,
              toName: targetData.name,
              coords: [dataItem.lat, targetData.lat],
            })
          }
          return res
        }
        var convertData2 = function (data) {
          var res = []
          for (var i = 0; i < data.length; i++) {
            var dataItem = data[i]
            res.push({
              name: dataItem.name,
              value: dataItem.lat.concat(dataItem.value),
            })
          }
          return res
        }
        var series = []
        if(this.chartOption.line_type == 'circle'){
          series.push(
            {
              type: 'lines',
              zlevel: 1,
              effect: {
                show: true,
                period: 3,
                trailLength: 0.5,
                color: '#fff',
                symbolSize: 4,
              },
              lineStyle: {
                normal: {
                  color: '#5EF3FF',
                  width: 1,
                  curveness: 0.3,
                },
              },
              data: convertData(sourceData, targetData),
            },
            {
              type: 'lines',
              zlevel: 2,
              symbol: ['none', 'arrow'],
              symbolSize: 4,
              effect: {
                show: true,
                period: 6,
                trailLength: 0,
                symbol: 'none',
                symbolSize: 10,
              },
              lineStyle: {
                normal: {
                  color: '#5EF3FF',
                  width: 1,
                  curveness: 0.3,
                },
              },
              data: convertData(sourceData, targetData),
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              zlevel: 2,
              rippleEffect: {
                brushType: 'stroke',
              },
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  formatter: '{b}',
                  fontSize: 18,
                },
              },
              symbolSize: function (val) {
                return val[2] / 8
              },
              itemStyle: {
                normal: {
                  color: '#02B6E4',
                },
              },
              data: sourceData.map(function (dataItem) {
                return {
                  name: dataItem.name,
                  value: dataItem.lat.concat([dataItem.value]),
                }
              }),
            },
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              data: convertData2(sourceData),
              symbolSize: (val) => {
                return val[2] / 5 // 后续要根据实际调整
              },
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: false,
                },
              },
              itemStyle: {
                normal: {
                  borderWidth: 0,
                  shadowColor: '#00E8D7',
                  shadowBlur: 50,
                },
                emphasis: {
                  borderColor: '#fff',
                  borderWidth: 1,
                },
              },
            }
          )
        }else{
          const colorList = themeColor(this.theme_color);
        let coord = sourceData.map((item,index) => {
          return {
            num: item.value,
            itemStyle: { color: colorList[index % colorList.length] },
            name: item.name,
            value: item.lat
          }
        });
        const lines_coord = []
        coord.forEach((item, index) => {
          lines_coord.push({
            lineStyle: { color: colorList[index % colorList.length] },
            coords: [item.value, targetData.lat]
          })
        })
        let otherTargetData = [{
          "name": targetData.name,
          "value":targetData.lat,
          "num": targetData.value,
          itemStyle: { color: this.chartOption['targetItemStyle']['itemStyle']['color']}
        }]
        series = [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 15,
            symbolSize: 10,
            data: coord
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 15,
            ...this.chartOption.targetItemStyle,
            data: otherTargetData
          },
          {
            type: 'lines',
            coordinateSystem: 'geo',
            zlevel: 15,
            effect: {
              show: true, period: 4, trailLength: 0.4, symbol: 'arrow', symbolSize: 7,
            },
            lineStyle: {
              normal: { width: 1, opacity: 0.6, curveness: 0.3 }
            },
            data: lines_coord
          }
        ]
        }
        var option = {
          title: {
            left: 'left',
            textStyle: {
              fontSize: '13',
              color: '#fff',
            },
          },
          visualMap: {
            min: 0,
            max: 300,
            calculable: true,
            show: true,
            inRange: {
              color: ['#5EF3FF', '#FF4500', '#F7E454', '#FFD700'],
            },
            textStyle: {
              color: '#fff',
            },
            ...this.chartOption.hasOwnProperty('visualMap') ? this.chartOption['visualMap'] : {}
          },
          geo: {
            map: 'china',
            top: 10,
            bottom: 30,
            left: 60,
            roam: true,
            ...this.chartOption
          },
          series: series,
        }
        this.chart.setOption(option)
        let that = this;
        this.chart.on('click', function (object) {
          let obj = {name:object.name};
          if(object.hasOwnProperty('data')){
            obj.data = object.data;
          }
          that.$emit('input', obj);
          that.$emit('change',obj);
        })
    }
  },
}
// 区域地图
var benbenAreaMap = {
  template: `<div @click.self="handleClick" class="benben-area-map CustomChart" style="position: relative;"> 
        <div v-if="show_title=='true'" class="chart-title"  @click="handleClick"  :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{title_name}}</div>
        <div :class="show_title=='true'?'chart-body':'chart-body-no-title'" style="overflow: hidden;position: relative;">
        <div  :id="cId" style="width:100%;height:100%"></div>
        <div class="legend-box">
          <div class="legend-item" v-if="map.legendArr.length"
            v-for="(v, i) in map.legendArr" :key="i" :class="{ disabled: map.currLegend !== v }"
            @click.stop="handleLegendChange(v, chartData.color[i])"
          >
            <div class="icon " :style="{ background: chartData.color[i] }"></div><span>{{ v }}</span> </div>
        </div>
        <div
          v-if="!hide_rank&&top10Rank.length"
          class="top10-box"
          :class="{ expanded: top10Expanded }"
          :style="{ borderColor: map.currLegendColor, height: 26 + 23 * top10Rank.length + 'px' }"
        >
          <div class="title" :style="{ background: map.currLegendColor }">
            <a-icon type="double-left" v-if="!top10Expanded" @click="top10Expand" style="margin-left: 6px;"/>
            <span style="margin: 0 12px">Top10</span>
            <a-icon type="double-right" v-if="top10Expanded" @click="top10Expand"/>
          </div>
          <div class="list">
            <div v-for="(v, i) in top10Rank" :key="i" class="item" :title="v.name + ' '+ v.value">
              {{ v.name.slice(0, 6)+ ' '+ v.value }}
            </div>
          </div>
        </div>
      </div>
        </div>`,
  name: 'benben-area-map',
  data() {
    return {
      cId: '',
      chart: null,
      map: {
        currLegend: '',
        currLegendColor: '',
        legendArr: [],
        region_code: '',
        data: null
      },
      top10Expanded: true,
      chartData: {}
    }
  },
  props: {
    show_title: {
      type: String,
      default: "true",
    },
    title_position: {
      type: String,
      default: 'middle',
    },
    title_name: {
      type: String,
      default: '标题',
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () =>{},
    },
    theme_color: {
      type: Array,
      default: () => [],
    },
    data_source_field_name: {
      type: Object,
      default: () =>{}
    },
    hide_rank: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    chartOption() {
      var [name, ...legendArr] = this.chartData.columns || [],
        rows = this.chartData.map_value || [],
        series = [],
        min = 0,
        max = 0,
        color = this.chartData.color,
        zoom = this.map.region_code == 'china' ? 1.3 : 1.15,
        top = this.map.region_code == 'china' ? 100 : 0
      if (legendArr.length) {
        series.push({
          type: 'map',
          map: this.map.region_code,
          roam: true,
          label: { show: true },
          zoom: zoom,
          top: top,
          itemStyle: { normal: { areaColor: "#87cefa", label: { show: true } }, emphasis: { areaColor: this.chartData.color[0], borderWidth: 2, label: { color: '#fff' } } },
          data: rows.map((v) => {
            var value = v[this.map.currLegend]
            min = Math.min(min, value)
            max = Math.max(max, value)
            let r_name = (v[name]+'').replace('省','').replace('市','').replace('自治区','')
            return { ...v, name: r_name, value }
          })
        })
      }
      return {
        color: this.chartData.color,
        tooltip: {
          formatter({ name, data }) {
            var getPoint = (color) =>
              `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>`,
              listTpl = legendArr
                .map((key, i) => `${getPoint(color[i])}<span>${key}: ${data ? data[key] : 0}</span>`)
                .join('<br />')
            return `${name}<br />${listTpl}`
          }
        },
        visualMap: {
          show: true,
          left: '5%',
          bottom: '1%',
          min,
          max,
          text: ['高', '低'],
          realtime: false,
          calculable: true,
          inRange: {
            color: this.chartData.color || ['lightskyblue', 'yellow', 'orangered']
          },
          textStyle: { color: '#fff' }
        },
        series: series
      }
    },
    top10Rank({ map: { currLegend }, chartOption: { series } }) {
      if (this.chartData && currLegend && series[0]) {
        return series[0].data.sort((a, b) => b.value - a.value).slice(0, 10)
      }
      return []
    },
  },
  created() {
    this.cId = guid(16)
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.handleResize);
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
    renderChart() {
      var that = this
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.chartData = { ...this.fieldOptions, color: themeColor(this.theme_color) }
        this.map.region_code = 'china'
        echarts.registerMap(that.map.region_code, mapdata)
          if (!that.map.currLegend) {
            that.map.legendArr = (that.chartData.columns || []).slice(1)
            that.map.currLegend = that.map.legendArr[0] || ''
            that.map.currLegendColor = that.chartData.color[0]
          }
          console.log(that.chartOption,'that.chartOption')
          that.chart.setOption(that.chartOption)
      } else if (this.data_source_type == '2') {
        if (this.data_source_field_name) {
          var resData = this.data_source_field_name
          this.chartData = { ...resData, color: themeColor(this.theme_color) }
          this.map.region_code = resData.region_code || 'china'
          echarts.registerMap(that.map.region_code, mapdata)
          if (!that.map.currLegend) {
            that.map.legendArr = (that.chartData.columns || []).slice(1)
            that.map.currLegend = that.map.legendArr[0] || ''
            that.map.currLegendColor = that.chartData.color[0]
          }
          that.chartData = { ...resData, color: themeColor(that.theme_color) }
          that.chart.setOption(that.chartOption)
        }
      }
    },
    // 切换地图图例
    handleLegendChange(currLegend, currLegendColor) {
      this.map.currLegend = currLegend
      this.map.currLegendColor = currLegendColor
      this.renderChart()
    },
    // Top10展开/折叠
    top10Expand() {
      this.top10Expanded = !this.top10Expanded
    },
    handleResize() {
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 500)
    }
  },
}
//3D饼图
var benbenThreeDimensionalPie = {
  name: 'benben-three-dimensional-pie',
  data() {
    return {
      options: {},
    }
  },
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.setPie(this.fieldOptions.data)
        this.chart.setOption(this.options)
      } else if (this.data_source_type == '2') {
        this.setPie(this.data_source_field_name.chart_data)
        this.chart.setOption(this.options)
      }
    },
    setPie(optionsData) {
      var series = this.getPie3D(optionsData, 0.5)
      series.push({
        name: 'pie2d',
        type: 'pie',
        startAngle: -50, //起始角度，支持范围[0, 360]。
        clockwise: false, //饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['20%', '50%'],
        center: ['50%', '50%'],
        data: optionsData,
        itemStyle: {
          opacity: 0,
        },
        labelLine: {
          show: false,
        },
      })
      this.options = {
        legend: this.chartOption.legend,
        color: themeColor(this.theme_color),
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
              var bfb = (
                (this.options.series[params.seriesIndex].pieData.endRatio - this.options.series[params.seriesIndex].pieData.startRatio) *
                100
              ).toFixed(2)
              return `${params.seriesName} ${optionsData[params.seriesIndex].value} <br/>` + `${bfb}%`
            }
          },
        },
        xAxis3D: {
          min: -1,
          max: 1,
        },
        yAxis3D: {
          min: -1,
          max: 1,
        },
        zAxis3D: {
          min: -1,
          max: 1,
        },
        grid3D: {
          show: false,
          boxHeight: 25, // 三维笛卡尔坐标系在三维场景中的高度
          left: this.chartOption.seriesSetting&&this.chartOption.seriesSetting.left || 'auto',
          top:  this.chartOption.seriesSetting&&this.chartOption.seriesSetting.top || 'auto',
          viewControl: {
            alpha: 45,
            // beta: 1000,
            distance: 320, //调整视角到主体的距离，类似调整zoom
            rotateSensitivity: 0, // 设置为0无法旋转
            zoomSensitivity: 0, // 设置为0无法缩放
            panSensitivity: 0, // 设置为0无法平移
            autoRotate: true, // 自动旋转
            autoRotateSpeed:  this.chartOption.labelSetting.threeDimLabel.animationDuration ? this.chartOption.labelSetting.threeDimLabel.animationDuration : 50, // 自动旋转速度
          },
           //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
           postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决 
            enable: true,
            bloom: {
              enable: true,
              bloomIntensity: 0.1
            },
            SSAO: {
              enable: true,
              quality: 'medium',
              radius: 20
            }
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          labelLine: {
            show: false,
          },
        },
        series: series,
      }
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      var midRatio = (startRatio + endRatio) / 2
      var startRadian = startRatio * Math.PI * 2
      var endRadian = endRatio * Math.PI * 2
      var midRadian = midRatio * Math.PI * 2
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = 1
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1
      // 返回曲面参数方程
      const reduceH = 0.3;
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32,
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20,
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u)- reduceH
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1- reduceH
          }
          return Math.sin(v) > 0 ? 1 * h * 0.1 - reduceH : -1
        },
      }
    },
    //构建饼图数据,绘制3d图  internalDiameterRatio:透明的空心占比
    getPie3D(pieData, internalDiameterRatio) {
      var series = []
      // 新增标签 series @20210613
      var labelSeries = {
        id: 'labelSeries',
        type: 'bar3D',
        //zlevel:-9,
        barSize: [0.1, 0.1],
        data: [],
        splitLine: {
          show: false,
        },
        label: {
          show: true,
          formatter: function (params) {
            return `${params.name}\n`
          },
          color: this.chartOption.labelSetting.threeDimLabel.color ? this.chartOption.labelSetting.threeDimLabel.color : "#fff",
          fontSize: this.chartOption.labelSetting.threeDimLabel.fontSize ? this.chartOption.labelSetting.threeDimLabel.fontSize : 16
        },
      }
      var sumValue = 0
      var startValue = 0
      var endValue = 0
      var legendData = []
      var k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (var i = 0; i < pieData.length; i += 1) {
        sumValue += Number(pieData[i].value)
        var seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k,
          },
          itemStyle: {},
        }
        if (typeof pieData[i].itemStyle !== 'undefined') {
          var itemStyle = {}
          if (typeof pieData[i].itemStyle.color !== 'undefined') {
            itemStyle.color = pieData[i].itemStyle.color
          }
          if (typeof pieData[i].itemStyle.opacity !== 'undefined') {
            itemStyle.opacity = pieData[i].itemStyle.opacity
          }
          seriesItem.itemStyle = itemStyle
        }
        series.push(seriesItem)
      }
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      for (var i = 0; i < series.length; i += 1) {
        endValue = startValue + Number(series[i].pieData.value)
        series[i].pieData.startRatio = startValue / sumValue
        series[i].pieData.endRatio = endValue / sumValue
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          25 //高度
        )
        startValue = endValue
        legendData.push(series[i].name)
        // 判断增加 label 效果 @20210613
        pieData[i].label = { show: true }
        if (pieData[i].label && pieData[i].label.show) {
          var labelRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI
          // labelSeries.color = themeColor(this.theme_color)[i]
          labelSeries.data.push({
            name: this.getLabelFormatter(series[i].name,Number(series[i].pieData.value),sumValue),
            value: [Math.cos(labelRadian), Math.sin(labelRadian), 1.2, Number(series[i].pieData.value)],
            itemStyle: {
              opacity: 1,
            },
          })
        }
      }
      series.push(labelSeries)
      return series
    },
    getLabelFormatter(name, value, totalValue) {
      let formatter = this.chartOption.labelSetting.threeDimLabel.formatter || '{b}'
      let percentage = ((value / totalValue) * 100).toFixed(2);
      let result = ''
      switch (formatter) {
        case '{b}':
          result = name
          break
        case '{c}':
          result = value
          break
          case '{d}%':
          result = value
          break
          case '{b}: {c}':
          result = `${name}: ${value}`
          break
          case '{b}: {d}%':
          result = `${name}: ${percentage}%`
          break
          case '{b}: {c} {d}%':
          result = `${name}: ${value} ${percentage}%`
          break
      }
      return result;
    },
  },
}
// 3D圆环
var benbenThreeDimensionalRing = {
  name: 'benben-three-dimensional-ring',
  data() {
    return {
      options: {}
    }
  },
  mixins:[mixinsBaseProps,mixinsResize],
  computed: {
    threeDimLabelColor() {
      var color = this.chartOption.labelSetting ? this.chartOption.labelSetting.threeDimLabel.color : "#fff"
      return color
    }
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.setPie(this.fieldOptions.data)
        this.chart.setOption(this.options);
      } else if (this.data_source_type == '2') {
        this.setPie(this.data_source_field_name.chart_data)
        this.chart.setOption(this.options);
      }
    },
    setPie(optionsData) {
      this.options = this.getPie3D(optionsData, this.chartOption.seriesSetting&&this.chartOption.seriesSetting.innerCircleProportion ? Number(this.chartOption.seriesSetting.innerCircleProportion) : 0.5)
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      var midRatio = (startRatio + endRatio) / 2;
      var startRadian = startRatio * Math.PI * 2;
      var endRadian = endRatio * Math.PI * 2;
      var midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== 'undefined' ? k : 1 / 3;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1;
      const reduceH = 0.4;
      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u)-reduceH;
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * .1-reduceH;
          }
          return Math.sin(v) > 0 ? 1 * h * .1-reduceH : -1;
        }
      };
    },
    // 生成模拟 3D 饼图的配置项
    getPie3D(pieData, internalDiameterRatio) {
      var series = [];
      // 新增标签 series @20210613
      var labelSeries = {
        id: 'labelSeries',
        type: 'bar3D',
        //zlevel:-9,
        barSize: [0.1, 0.1],
        data: [],
        splitLine: {
          show: false,
        },
        label: {
          show: true,
          formatter: function (params) {
            return `${params.name}\n`
          },
          color: this.chartOption.labelSetting.threeDimLabel.color ? this.chartOption.labelSetting.threeDimLabel.color : "#fff",
          fontSize: this.chartOption.labelSetting.threeDimLabel.fontSize ? this.chartOption.labelSetting.threeDimLabel.fontSize : 16
        },
      }
      var sumValue = 0;
      var startValue = 0;
      var endValue = 0;
      var legendData = [];
      var k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3;
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (var i = 0; i < pieData.length; i++) {
        sumValue += Number(pieData[i].value)
        var seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k
          }
        };
        if (typeof pieData[i].itemStyle != 'undefined') {
          var itemStyle = {};
          typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
          typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      for (var i = 0; i < series.length; i++) {
        endValue = startValue + Number(series[i].pieData.value)
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, false, k, 25);
        startValue = endValue;
        legendData.push(series[i].name);
        // 判断增加 label 效果 @20210613
        pieData[i].label = { show: true }
        if (pieData[i].label && pieData[i].label.show) {
          var labelRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI
          labelSeries.data.push({
            name: this.getLabelFormatter(series[i].name,Number(series[i].pieData.value),sumValue),
            value: [Math.cos(labelRadian)*3/5, Math.sin(labelRadian)*3/5, 1.2, Number(series[i].pieData.value)],
            itemStyle: {
              opacity: 1,
            },
          })
        }
      }
      // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
      series.push(labelSeries)
      series.push({
        type: 'surface',
        name: '',
        parametric: true,
        wireframe: {
          show: false
        },
        itemStyle: {
          opacity: 0
        },
        parametricEquation: {
          u: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },
          v: {
            min: 0,
            max: Math.PI,
            step: Math.PI / 20
          },
          x: function (u, v) {
            return Math.sin(v) * Math.sin(u) + Math.sin(u);
          },
          y: function (u, v) {
            return Math.sin(v) * Math.cos(u) + Math.cos(u);
          },
          z: function (u, v) {
            return Math.cos(v) > 0 ? 0.1 : -0.1;
          }
        }
      });
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      var option = {
        //animation: false,
        legend: this.chartOption.legend,
        color: themeColor(this.theme_color),
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== '') {
              var bfb = (
                (this.options.series[params.seriesIndex].pieData.endRatio -
                  this.options.series[params.seriesIndex].pieData.startRatio) *
                100
              ).toFixed(2);
              return (
                `${params.seriesName} ${pieData[params.seriesIndex].value} <br/>` +
                `${bfb}%`
              );
            }
          },
        },
        label: {
          opacity: 1,
          fontSize: 14,
          lineHeight: 20,
          show: true,
          position: 'center'
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1.2
        },
        grid3D: {
          show: false,
          boxHeight: 10,
          left: this.chartOption.seriesSetting&&this.chartOption.seriesSetting.left || 'auto',
          top:  this.chartOption.seriesSetting&&this.chartOption.seriesSetting.top || 'auto',
          viewControl: {//3d效果可以放大、旋转等，请自己去查看官方配置
            alpha: 40,
            // beta: 40,
            distance: 210, //调整视角到主体的距离，类似调整zoom
            rotateSensitivity: 0,
            zoomSensitivity: 0,
            panSensitivity: 0,
            autoRotate: true,
            autoRotateSpeed:  this.chartOption.labelSetting.threeDimLabel.animationDuration ? this.chartOption.labelSetting.threeDimLabel.animationDuration : 50, // 自动旋转速度
          },
          //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
          postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决 
            enable: true,
            bloom: {
              enable: true,
              bloomIntensity: 0.1
            },
            SSAO: {
              enable: true,
              quality: 'medium',
              radius: 2
            }
          }
        },
        series: series
      };
      return option;
    },
    getLabelFormatter(name, value, totalValue) {
      let formatter = this.chartOption.labelSetting.threeDimLabel.formatter || '{b}'
      let percentage = ((value / totalValue) * 100).toFixed(2);
      let result = ''
      switch (formatter) {
        case '{b}':
          result = name
          break
        case '{c}':
          result = value
          break
          case '{d}%':
          result = value
          break
          case '{b}: {c}':
          result = `${name}: ${value}`
          break
          case '{b}: {d}%':
          result = `${name}: ${percentage}%`
          break
          case '{b}: {c} {d}%':
          result = `${name}: ${value} ${percentage}%`
          break
      }
      return result;
    },
  },
}
// 3D柱图
var benbenThreeDimensionalBar = {
  name: 'benben-three-dimensional-bar',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        if (this.fieldOptions.series.length) {
          this.commonInit(this.fieldOptions.xAxis.data, this.fieldOptions.series[0].data);
        }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        if (sourceData && sourceData.series) {
          if (sourceData.series.length && sourceData.series[0].data.length) {
            this.commonInit(sourceData.xAxis.data, sourceData.series[0].data);
          }
        }
      }
    },
    commonInit(xAxis, series) {
      var morColor = themeColor(this.theme_color);
      var morGradientColor = themeColor(this.theme_color);
      var morData = series;
      var xData = xAxis;
      var v2L2Chart = {
        xData: xData,
        data: morData,
        max: Math.max(...morData),
        color: morColor
      };
      var bottomCircleData = [];
      var bottomBar = [];
      var headerOne = [];
      var headerTwo = [];
      var bottomData = [];
      var morBarWidth = this.chartOption.barSetting.barWidth;
      if (xData.length && morData.length) {
        bottomCircleData = morData.map((value, index) => ({
          name: '',
          value: '0',
          itemStyle: {
            normal: {
              color: morColor[index % morColor.length]
            },
          },
        }));
        var alphaValue = 0.8;
        bottomBar = morData.map((value, index) => ({
          name: '',
          value: value,
          itemStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: 'linear',
                global: false,
                colorStops: [
                  {
                    //第一节下面
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[index % morGradientColor.length], alphaValue),
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[index % morColor.length], alphaValue)
                  },
                ],
              },
            },
          },
        }));
        headerOne = morData.map((value, index) => ({
          name: '',
          value: value,
          symbolPosition: 'end',
          label: {
            formatter: '{c}',
            color: '#fff',
            offset: [0, -5],
            show: true,
            position: 'top',
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'zcool-gdh',
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[index % morGradientColor.length], alphaValue),
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[index % morColor.length], alphaValue),
                  },
                ],
                false
              ),
            },
          },
        }));
        headerTwo = morData.map((value, index) => ({
          name: '',
          value: v2L2Chart.max,
          symbolPosition: 'end',
          itemStyle: {
            normal: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.6,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[index % morGradientColor.length], alphaValue), // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[index % morColor.length], alphaValue), // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
          }
        }));
        bottomData = morData.map((value, index) => ({
          name: '',
          value: Number(v2L2Chart.max) - Number(value),
          symbolPosition: 'end',
          itemStyle: {
            normal: {
              color: this.normalizeColor(morColor[index % morColor.length], 0.4),
            },
          }
        }));
      }
      var option = {
        // grid: {
        //   top: '5%',
        //   left: '10%',
        //   right: '9%',
        //   bottom: '40%',
        // },
        dataZoom:[{
          show:xData.length>6?true:false,
          type: 'slider',
          start:0,
          end:xData.length>10?60:100,
          height:10
        }],
        tooltip: {
          show: true,
          formatter: function (params) {
            var text = '<p  style="font-size:16px;font-weight: 400;color:rgba(255, 255, 255, 1);margin-bottom: 20px;"><span style="display:inline-block;width:10px;height: 10px;background: ' + v2L2Chart.color[params.dataIndex] + ';border-radius: 50%;margin-right: 10px;"></span>' + v2L2Chart.xData[params.dataIndex] + '：' + v2L2Chart.data[params.dataIndex] + '</p>';
            return text
          },
          backgroundColor: 'rgba(38, 68, 110, 0.8)',
          padding: 10,
          borderColor: 'rgba(38, 68, 110, 1)',
          textStyle: {
            color: '#fff',
          }
        },
        xAxis: {
          offset: 20,
          data: v2L2Chart.xData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14,
            },
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
        },
        series: [
          //'最低下的圆片',
          {
            name: '最低下的圆片',
            stack: 'a',
            type: 'effectScatter',
            symbolSize: [morBarWidth - 4, 12],
            symbolOffset: [0, 0],
            z: 22,
            data: bottomCircleData
          },
          //下半截柱状图
          {
            name: '下半截柱状图',
            stack: 'a',
            type: 'bar',
            barWidth: morBarWidth,
            z: 2,
            barGap: '-100%',
            data: bottomBar
          },
          //替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20'
          {
            name: '替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20',
            stack: 'a',
            type: 'bar',
            barWidth: morBarWidth,
            barGap: '-100%',
            stack: '广告',
            itemStyle: {
              color: 'transparent',
            },
            data: morData,
          },
          //头部1
          {
            name: '头部1',
            stack: 'a',
            type: 'pictorialBar',
            symbolSize: [morBarWidth, 12],
            symbolOffset: [0, -6],
            z: 22,
            data: headerOne
          },
          //头部2
          {
            name: '头部2',
            stack: 'a',
            type: 'pictorialBar',
            symbolSize: [morBarWidth, 12],
            symbolOffset: [0, -6],
            z: 22,
            data: headerTwo,
          },
          //底色
          {
            name: '底色',
            stack: 'a',
            type: 'bar',
            barWidth: morBarWidth,
            z: 2,
            barGap: '-100%',
            stack: '广告',
            data: bottomData
          },
        ],
      };
      this.chart.setOption(option)
    },
    normalizeColor(color, alpha) {
      if (color.startsWith('#')) {
        // 如果是16进制格式，则转换为RGBA格式
        return this.hexToRgba(color, alpha);
      } else if (color.startsWith('rgba') || color.startsWith('rgb')) {
        // 如果是RGB或RGBA格式，则设置新的透明度
        return this.setAlpha(color, alpha);
      } else {
        // 如果是其他格式，保持原样
        return color;
      }
    },
    hexToRgba(hex, alpha) {
      // 将16进制颜色转换为RGBA格式
      var bigint = parseInt(hex.slice(1), 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    setAlpha(color, alpha) {
      return color.replace(/(rgba?\([^,]+,[^,]+,[^,]+)(,[^)]+)?\)/, `$1, ${alpha})`);
    },
  },
}
// 立方体柱图
var benbenCubeBar = {
  name: 'benben-cube-bar',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        this.commonInit(this.fieldOptions.series, this.fieldOptions.xAxis.data)
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name;
        var dataList = (sourceData && sourceData.data) || []
        if (dataList && dataList.length) {
          this.commonInit(dataList, sourceData.xAxis)
        }
      }
    },
    commonInit(dataList, xAxis) {
      let itemColor1 = themeColor(this.theme_color)[0];
      let itemColor2 = themeColor(this.theme_color)[0];
      let itemOffset = 1;
      let is_linear_gradient = false;
      let colorStops = [{
                    offset: 0,
                    color: itemColor1
                }, {
                    offset: 0.5,
                    color: itemColor1
                }, {
                    offset: 0.5,
                    color:  this.normalizeColor(itemColor1,0.9)
                }, {
                    offset: 1,
                    color:  this.normalizeColor(itemColor1,0.9)
                }];
      if( this.linear_gradient_color&&this.linear_gradient_color.length>0){
        let linear_gradient_color = this.linear_gradient_color;
        itemColor1 = linear_gradient_color[0].color1;
        itemColor2 = linear_gradient_color[0].color2;
        itemOffset = linear_gradient_color[0].start / 100;
        is_linear_gradient = true
        colorStops = [{
                    offset: 0,
                    color: itemColor1
                }, {
                    offset: itemOffset,
                    color: itemColor2
                }];
      }
      var dataOption = {
        tooltip: this.chartOption.tooltip,
        legend: this.chartOption.legend,
        grid: this.chartOption.grid,
        xAxis: {...this.chartOption.xAxis,data:xAxis},
        yAxis: this.chartOption.yAxis,
        series: [{
          data: dataList[0]['data'],
          type: "bar",
          barWidth:  this.chartOption.barSetting.barWidth,
          itemStyle: {
            color: {
              x: 0,
              y: 0,
              x2: is_linear_gradient?0:1,
              y2: is_linear_gradient?1:0,
              type: "linear",
              global: false,
              colorStops: colorStops
            }
          },
          label: {
            show: true,
            position: "top",
            distance: 10,
            color: "#fff"
          }
        }, {
          data: [1, 1, 1, 1, 1, 1, 1, 1],
          type: "pictorialBar",
          barMaxWidth: this.chartOption.barSetting.barWidth,
          symbol: "diamond",
          symbolOffset: [0, "50%"],
          symbolSize: [this.chartOption.barSetting.barWidth, 15],
        }, {
          data: dataList[0]['data'],
          type: "pictorialBar",
          barMaxWidth: this.chartOption.barSetting.barWidth,
          symbolPosition: "end",
          symbol: "diamond",
          symbolOffset: [0, "-50%"],
          symbolSize: [this.chartOption.barSetting.barWidth, 12],
          zlevel: 2,
        }],
      }
      dataOption.color = [itemColor2,itemColor1]
      this.chart.setOption(dataOption,{replaceMerge:['xAxis','series','yAxis']})
      if(dataOption.tooltip&&dataOption.tooltip.show&&dataOption.tooltip.autoToolTip){
        let dataOptionCopy = mixinCopyData(dataOption)
        dataOptionCopy.series = [dataOptionCopy.series[2]]
        initAutoToolTip(this.chart,dataOptionCopy,{loopSeries: true })
      }
    },
    normalizeColor(color, alpha) {
      if (color.startsWith('#')) {
        // 如果是16进制格式，则转换为RGBA格式
        return this.hexToRgba(color, alpha);
      } else if (color.startsWith('rgba') || color.startsWith('rgb')) {
        // 如果是RGB或RGBA格式，则设置新的透明度
        return this.setAlpha(color, alpha);
      } else {
        // 如果是其他格式，保持原样
        return color;
      }
    },
    hexToRgba(hex, alpha) {
      // 将16进制颜色转换为RGBA格式
      var bigint = parseInt(hex.slice(1), 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    setAlpha(color, alpha) {
      return color.replace(/(rgba?\([^,]+,[^,]+,[^,]+)(,[^)]+)?\)/, `$1, ${alpha})`);
    },
  },
}
// 3D背景柱图
var benbenThreeBarBackground = {
  name: 'benben-three-bar-background',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        if (this.fieldOptions.series.length) {
          this.commonInit(this.fieldOptions.xAxis.data, this.fieldOptions.series[0].data);
        }
      } else if (this.data_source_type == '2') {
        var sourceData = this.data_source_field_name
        if (sourceData && sourceData.series) {
          if (sourceData.series.length && sourceData.series[0].data.length) {
            this.commonInit(sourceData.xAxis.data, sourceData.series[0].data);
          }
        }
      }
    },
    commonInit(xAxis, series) {
      var morColor = themeColor(this.theme_color);
      var morGradientColor = themeColor(this.theme_color);
      var morData = series;
      var xData = xAxis;
      var v2L2Chart = {
        xData: xData,
        data: morData,
        max: Math.max(...morData),
        color: morColor
      };
      var bottomCircleData = [];
      var bottomBar = [];
      var headerOne = [];
      var headerTwo = [];
      var bottomData = [];
      var morBarWidth = this.chartOption.barSetting.barWidth;
      if (xData.length && morData.length) {
        bottomCircleData = morData.map((value, index) => ({
          name: '',
          value: '0',
          itemStyle: {
            normal: {
              color: morColor[0]
            },
          },
        }));
        var alphaValue = 0.8;
        bottomBar = morData.map((value, index) => ({
          name: '',
          value: value,
          itemStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: 'linear',
                global: false,
                colorStops: [
                  {
                    //第一节下面
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[0], alphaValue),
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[0], alphaValue)
                  },
                ],
              },
            },
          },
        }));
        headerOne = morData.map((value, index) => ({
          name: '',
          value: value,
          symbolPosition: 'end',
          label: {
            formatter: '{c}',
            color: '#fff',
            offset: [0, -5],
            show: true,
            position: 'top',
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'zcool-gdh',
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[0], alphaValue),
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[0], alphaValue),
                  },
                ],
                false
              ),
            },
          },
        }));
        headerTwo = morData.map((value, index) => ({
          name: '',
          value: v2L2Chart.max,
          symbolPosition: 'end',
          itemStyle: {
            normal: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.6,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: this.normalizeColor(morGradientColor[0], alphaValue), // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.normalizeColor(morColor[0], alphaValue), // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
          }
        }));
        bottomData = morData.map((value, index) => ({
          name: '',
          value: Number(v2L2Chart.max) - Number(value),
          symbolPosition: 'end',
          itemStyle: {
            normal: {
              color: this.normalizeColor(morColor[0], 0.4),
            },
          }
        }));
      }
      let series_option = [
        //'最低下的圆片',
        {
          name: '底部圆',
          type: 'pictorialBar',
          silent: true,
          symbolSize: [morBarWidth, 12],
          symbolOffset: [0, 7],
          z: 22,
          // color: '#C76B37',
          data: bottomCircleData,
       },
        //下半截柱状图
        {
          name: '下半截柱状图',
          stack: 'a',
          type: 'bar',
          barWidth: morBarWidth,
          z: 2,
          barGap: '-100%',
          data: bottomBar
        },
        //替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20'
        {
          name: '替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20',
          stack: 'a',
          type: 'bar',
          barWidth: morBarWidth,
          barGap: '-100%',
          stack: '广告',
          itemStyle: {
            color: 'transparent',
          },
          data: morData,
        },
        //头部1
        {
          name: '头部1',
          stack: 'a',
          type: 'pictorialBar',
          symbolSize: [morBarWidth, 12],
          symbolOffset: [0, -6],
          z: 22,
          data: headerOne
        },
        //底色
        {
          name: '底色',
          stack: 'a',
          type: 'bar',
          barWidth: morBarWidth,
          z: 2,
          barGap: '-100%',
          stack: '广告',
          data: bottomData
        },
      ]
      if(this.is_show_top){
        series.push({
          name: '头部2',
          stack: 'a',
          type: 'pictorialBar',
          symbolSize: [morBarWidth, 12],
          symbolOffset: [0, -6],
          z: 22,
          data: headerTwo,
        })
      }
      var option = {
        // grid: {
        //   top: '5%',
        //   left: '10%',
        //   right: '9%',
        //   bottom: '40%',
        // },
        dataZoom:[{
          show:xData.length>6?true:false,
          type: 'slider',
          start:0,
          end:xData.length>10?60:100,
          height:10
        }],
        tooltip: {
          show: true,
          formatter: function (params) {
            var text = '<p  style="font-size:16px;font-weight: 400;color:rgba(255, 255, 255, 1);margin-bottom: 20px;"><span style="display:inline-block;width:10px;height: 10px;background: ' + v2L2Chart.color[params.dataIndex] + ';border-radius: 50%;margin-right: 10px;"></span>' + v2L2Chart.xData[params.dataIndex] + '：' + v2L2Chart.data[params.dataIndex] + '</p>';
            return text
          },
          backgroundColor: 'rgba(38, 68, 110, 0.8)',
          padding: 10,
          borderColor: 'rgba(38, 68, 110, 1)',
          textStyle: {
            color: '#fff',
          }
        },
        xAxis: {
          offset: 20,
          data: v2L2Chart.xData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14,
            },
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
        },
        series: series_option,
      };
      this.chart.setOption(option)
    },
    normalizeColor(color, alpha) {
      if (color.startsWith('#')) {
        // 如果是16进制格式，则转换为RGBA格式
        return this.hexToRgba(color, alpha);
      } else if (color.startsWith('rgba') || color.startsWith('rgb')) {
        // 如果是RGB或RGBA格式，则设置新的透明度
        return this.setAlpha(color, alpha);
      } else {
        // 如果是其他格式，保持原样
        return color;
      }
    },
    hexToRgba(hex, alpha) {
      // 将16进制颜色转换为RGBA格式
      var bigint = parseInt(hex.slice(1), 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    setAlpha(color, alpha) {
      return color.replace(/(rgba?\([^,]+,[^,]+,[^,]+)(,[^)]+)?\)/, `$1, ${alpha})`);
    },
  },
}
// 3D间隔圆环
var benbenThreeDimensionalSpaceRing = {
  name: 'benben-three-dimensional-space-ring',
  data() {
    return {
      options: {}
    }
  },
  mixins:[mixinsBaseProps,mixinsResize],
  computed: {
    threeDimLabelColor() {
      var color = this.chartOption.labelSetting ? this.chartOption.labelSetting.threeDimLabel.color : "#fff"
      return color
    }
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.setPie(this.fieldOptions.data)
        this.chart.setOption(this.options);
      } else if (this.data_source_type == '2') {
        this.setPie(this.data_source_field_name.chart_data)
        this.chart.setOption(this.options);
      }
    },
    setPie(optionsData) {
      this.options = this.getPie3D(optionsData, this.chartOption.innerCircleProportion ? Number(this.chartOption.innerCircleProportion) : 0.5)
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      var midRatio = (startRatio + endRatio) / 2;
      var angleOffset = 0.08;
      var startRadian = startRatio * Math.PI * 2 + angleOffset;
      var endRadian = endRatio * Math.PI * 2 - angleOffset;;
      var midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== 'undefined' ? k : 1 / 3;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1;
      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * .1;
          }
          return Math.sin(v) > 0 ? 1 * h * .1 : -1;
        }
      };
    },
    // 生成模拟 3D 饼图的配置项
    getPie3D(pieData, internalDiameterRatio) {
      var series = [];
      // 新增标签 series @20210613
      let labelSeries = {
       id: 'labelSeries',
       type: 'bar3D',
       //zlevel:-9,
       barSize: [0.1, 0.1],
       data: [],
       splitLine: {
         show: false,
       },
       label: {
        show: true,
        formatter: function (params) {
          return `${params.name}\n`
        },
        color: this.chartOption.labelSetting.threeDimLabel.color ? this.chartOption.labelSetting.threeDimLabel.color : "#fff",
        fontSize: this.chartOption.labelSetting.threeDimLabel.fontSize ? this.chartOption.labelSetting.threeDimLabel.fontSize : 16
      },
     }
      var sumValue = 0;
      var startValue = 0;
      var endValue = 0;
      var legendData = [];
      var k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3;
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (var i = 0; i < pieData.length; i++) {
        sumValue += Number(pieData[i].value)
        // sumValue += pieData[i].value;
        var seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k
          }
        };
        if (typeof pieData[i].itemStyle != 'undefined') {
          var itemStyle = {};
          typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
          typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      for (var i = 0; i < series.length; i++) {
        // endValue = startValue + series[i].pieData.value;
        endValue = startValue + Number(series[i].pieData.value)
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, false, k, 25);
        startValue = endValue;
        legendData.push(series[i].name);
          // 判断增加 label 效果 @20210613
          pieData[i].label = { show: true }
          if (pieData[i].label && pieData[i].label.show) {
            var labelRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI
            labelSeries.data.push({
              name: this.getLabelFormatter(series[i].name,Number(series[i].pieData.value),sumValue),
              value: [Math.cos(labelRadian)*3/5, Math.sin(labelRadian)*3/5, 1.2, Number(series[i].pieData.value)],
              itemStyle: {
                opacity: 1,
              },
            })
          }
      }
      series.push(labelSeries)
      // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
      series.push({
        type: 'surface',
        name: '',
        parametric: true,
        wireframe: {
          show: false
        },
        itemStyle: {
          opacity: 0
        },
        parametricEquation: {
          u: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },
          v: {
            min: 0,
            max: Math.PI,
            step: Math.PI / 20
          },
          x: function (u, v) {
            return Math.sin(v) * Math.sin(u) + Math.sin(u);
          },
          y: function (u, v) {
            return Math.sin(v) * Math.cos(u) + Math.cos(u);
          },
          z: function (u, v) {
            return Math.cos(v) > 0 ? 0.1 : -0.1;
          }
        }
      });
      // 准备待返回的配置项，把准备好的 legendData、series 传入。
      var option = {
        //animation: false,
        legend: this.chartOption.legend,
        color: themeColor(this.theme_color),
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== '') {
              var bfb = (
                (this.options.series[params.seriesIndex].pieData.endRatio -
                  this.options.series[params.seriesIndex].pieData.startRatio) *
                100
              ).toFixed(2);
              return (
                `${params.seriesName} ${pieData[params.seriesIndex].value} <br/>` +
                `${bfb}%`
              );
            }
          },
        },
        label: {
          opacity: 1,
          fontSize: 14,
          lineHeight: 20,
          show: true,
          position: 'left'
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        grid3D: {
          show: false,
          boxHeight: 5,
          viewControl: {//3d效果可以放大、旋转等，请自己去查看官方配置
            alpha: 40,
            // beta: 40,
            rotateSensitivity: 0,
            zoomSensitivity: 0,
            panSensitivity: 0,
            autoRotate: true,
            autoRotateSpeed: 50,
          },
          //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
          // postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决 
          //     enable: true,
          //     bloom: {
          //         enable: true,
          //         bloomIntensity: 0.1
          //     },
          //     SSAO: {
          //         enable: true,
          //         quality: 'medium',
          //         radius: 2
          //     },
          //     graphic: {
          //       antialiasing: true  // 启用抗锯齿效果
          //     }
          // }
        },
        series: series
      };
      return option;
    },
    getLabelFormatter(name, value, totalValue) {
      let formatter = this.chartOption.labelSetting.threeDimLabel.formatter || '{b}'
      let percentage = ((value / totalValue) * 100).toFixed(2);
      let result = ''
      switch (formatter) {
        case '{b}':
          result = name
          break
        case '{c}':
          result = value
          break
          case '{d}%':
          result = value
          break
          case '{b}: {c}':
          result = `${name}: ${value}`
          break
          case '{b}: {d}%':
          result = `${name}: ${percentage}%`
          break
          case '{b}: {c} {d}%':
          result = `${name}: ${value} ${percentage}%`
          break
      }
      return result;
    },
  },
}
//3D饼图+底座
var benbenThreeDimensionalPieTwo = {
  name: 'benben-three-dimensional-pie-two',
  data() {
    return {
      options: {},
    }
  },
  mixins:[mixinsBaseProps,mixinsResize],
  computed: {
    threeDimLabelColor() {
      var color = this.chartOption.labelSetting ? this.chartOption.labelSetting.threeDimLabel.color : "#fff"
      return color
    }
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.setPie(this.fieldOptions.data)
        this.chart.setOption(this.options)
      } else if (this.data_source_type == '2') {
        this.setPie(this.data_source_field_name.chart_data)
        this.chart.setOption(this.options)
      }
    },
    setPie(optionsData) {
      var series = this.getPie3D(optionsData, 0.5,);
      series.push({
        name: 'pie2d',
        type: 'pie',
        labelLine: {
          show: false
        },
        startAngle: -50, //起始角度，支持范围[0, 360]。
        clockwise: false, //饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['20%', '50%'],
        center: ['50%', '50%'],
        data: optionsData,
        itemStyle: {
          opacity: 0,
        },
      });
      this.options =
      {
        legend: this.chartOption.legend,
        color: themeColor(this.theme_color),
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d' && params.seriesName != '') {
              return (
                `${params.seriesName} ${optionsData[params.seriesIndex].value} <br/>`
              );
            }
          },
        },
        xAxis3D: {
          min: -1,
          max: 1,
        },
        yAxis3D: {
          min: -1,
          max: 1,
        },
        zAxis3D: {
          min: -1,
          max: 1,
        },
        grid3D: {
          show: false,
          boxHeight: 12, // 三维笛卡尔坐标系在三维场景中的高度
          viewControl: {
            alpha: 30,
            // beta: 1000,
            distance: 300, //调整视角到主体的距离，类似调整zoom
            rotateSensitivity: 0, // 设置为0无法旋转
            zoomSensitivity: 0, // 设置为0无法缩放
            panSensitivity: 0, // 设置为0无法平移
            autoRotate: true, // 自动旋转
            autoRotateSpeed: 50
          },
          //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
          // postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决 
          //   enable: true,
          //   bloom: {
          //     enable: true,
          //     bloomIntensity: 0.1
          //   },
          //   SSAO: {
          //     enable: true,
          //     quality: 'low',
          //     radius: 2
          //   },
          //   graphic: {
          //     antialiasing: true  // 启用抗锯齿效果
          //   }
          // },
          splitLine: {
            show: true,
          },
          axisLabel: {
            show: false,
          }
        },
        series: series,
      };
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      // 计算
      var midRatio = (startRatio + endRatio) / 4;
      var startRadian = startRatio * Math.PI * 2;
      var endRadian = endRatio * Math.PI * 2;
      var midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = 1;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1;
      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32,
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20,
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1;
          }
          return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
        },
      };
    },
    //构建饼图数据,绘制3d图  internalDiameterRatio:透明的空心占比
    getPie3D(pieData, internalDiameterRatio, distance, alpha, pieHeight, opacity = 1) {
      var series = [];
      var labelSeries = {
        id: 'labelSeries',
        type: 'bar3D',
        //zlevel:-9,
        barSize: [0.1, 0.1],
        data: [],
        splitLine: {
          show: false,
        },
        label: {
          show: true,
          formatter: function (params) {
            return `${params.name}\n`
          },
          color: this.threeDimLabelColor,
          fontSize: 16,
        },
      }
      var sumValue = 0;
      var startValue = 0;
      var endValue = 0;
      var legendData = [];
      var k =
        typeof internalDiameterRatio !== 'undefined'
          ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
          : 1 / 3;
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (var i = 0; i < pieData.length; i += 1) {
        sumValue += pieData[i].value;
        var seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          // shading: 'color', // 添加这一行
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k,
          },
        };
        if (typeof pieData[i].itemStyle !== 'undefined') {
          var itemStyle = {};
          if (typeof pieData[i].itemStyle.color !== 'undefined') {
            itemStyle.color = pieData[i].itemStyle.color;
          }
          if (typeof pieData[i].itemStyle.opacity !== 'undefined') {
            itemStyle.opacity = pieData[i].itemStyle.opacity;
          }
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }
      let morList = []
      for (var i = 0; i < series.length; i += 1) {
        morList.push(series[i].pieData.value)
      }
     let  numericArray = morList.map(value => (typeof value === 'string' ? parseFloat(value) : value));
     let maxValue = Math.max(...numericArray.filter(value => value > 100));
     let minValue = Math.min(...numericArray.filter(value => value < 40));
     let  scaleFactor = 1;
     let scaleNum =1;
     if (maxValue > 100) {
       scaleFactor = 100 / maxValue;
     }
     if(minValue<40){
      scaleNum = 40 / minValue;
     }
     morList= numericArray.map(value => (value > 100 ? value * scaleFactor:value <40 ? value * scaleNum : value));
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      for (var i = 0; i < series.length; i += 1) {
        endValue = startValue + series[i].pieData.value;
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          morList[i]
        );
        startValue = endValue;
        legendData.push(series[i].name);
          // 判断增加 label 效果 @20210613
          pieData[i].label = { show: true }
          if (pieData[i].label && pieData[i].label.show) {
            var labelRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI
            // labelSeries.color = themeColor(this.theme_color)[i]
            labelSeries.data.push({
              name: series[i].name,
              value: [Math.cos(labelRadian), Math.sin(labelRadian), 1.2, Number(series[i].pieData.value)],
              itemStyle: {
                opacity: 1,
              },
            })
          }
      }
      // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
      if(!this.hidden_base){
        series.push({
          name: '',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          itemStyle: {
            opacity: 0.2,
            color: '#145C94'
          },
          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20,
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20,
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 3.4;
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 3.4;
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? -0.2 : -2;
            },
          },
        });
      }
      series.push(labelSeries)
      return series;
    },
  },
}
//3D环图+底座
var benbenThreeDimensionalPieThree = {
  name: 'benben-three-dimensional-pie-three',
  data() {
    return {
      options: {},
    }
  },
  props:{
    fixed_height:false,
    data_max:10,
    box_height:5,
    label_distance:10
  },
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.setPie(this.fieldOptions.data)
        this.chart.setOption(this.options)
      } else if (this.data_source_type == '2') {
        this.setPie(this.data_source_field_name.chart_data)
        this.chart.setOption(this.options)
      }
    },
    setPie(optionsData) {
      var series = this.getPie3D(optionsData, 0.8, 240, 28, 26, 0.5);
      series.push({
        name: 'pie2d',
        type: 'pie',
        labelLine: {
          show:false
        },
        startAngle: -30, //起始角度，支持范围[0, 360]。
        clockwise: false, //饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['0%', '0%'],
        center: ['0%', '0%'],
        data: optionsData,
        itemStyle: {
          opacity: 0,
        },
      });
      this.options =
      {
        legend: this.chartOption.legend,
        color: themeColor(this.theme_color),
        animation: true,
        tooltip: {
          formatter: params => {
            if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d' && params.seriesName != '') {
              return `${params.seriesName}<br/><span style="display:inline-block;margin-right:5px;border-radius:5px;width:10px;height:10px;background-color:${params.color};"></span>${this.options.series[params.seriesIndex].pieData.value}`;
            }
          },
          textStyle: {
            fontSize: 16
          },
        },
        xAxis3D: {
          min: -1,
          max: 1,
        },
        yAxis3D: {
          min: -1,
          max: 1,
        },
        zAxis3D: {
          min: -1,
          max: 1,
        },
        grid3D: {
          show: false,
          boxHeight: this.box_height||6,
          bottom: '50%',
          viewControl: {
            distance: 240,
            alpha: 25,
            beta: 60,
            rotateSensitivity: 0, // 设置为0无法旋转
            zoomSensitivity: 0, // 设置为0无法缩放
            panSensitivity: 0, // 设置为0无法平移
            autoRotate: true, // 自动旋转
            autoRotateSpeed: 50,
          },
          // postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决 
          //   enable: true,
          //   bloom: {
          //     enable: true,
          //     bloomIntensity: 0.1
          //   },
          //   SSAO: {
          //     enable: true,
          //     quality: 'low',
          //     radius: 2
          //   },
          //   graphic: {
          //     antialiasing: true  // 启用抗锯齿效果
          //   }
          // },
        },
        series: series,
      }
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
      // 计算
      var midRatio = (startRatio + endRatio) / 2;
      var startRadian = startRatio * Math.PI * 2;
      var endRadian = endRatio * Math.PI * 2;
      var midRadian = midRatio * Math.PI * 2;
      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }
      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== 'undefined' ? k : 1 / 3;
      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1;
      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < - Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u);
          }
          return Math.sin(v) > 0 ? 1 * height : -1;
        }
      };
    },
    getPie3D(pieData, internalDiameterRatio) {
      var series = [];
      // 新增标签 series @20210613
      let labelSeries = {
        id: 'labelSeries',
        type: 'bar3D',
        // bevelSize:50,
        // distance:100,
        // zlevel:-9,
        barSize: [0.1, 0.1],
        data: [],
        splitLine: {
          show: false,
        },
        label: {
          show: true,
          distance:20,
          formatter: function (params) {
            return `${params.name}\n`
          },
          color: this.chartOption.labelSetting.threeDimLabel.color ? this.chartOption.labelSetting.threeDimLabel.color : "#fff",
          fontSize: this.chartOption.labelSetting.threeDimLabel.fontSize ? this.chartOption.labelSetting.threeDimLabel.fontSize : 16
        },
      }
      var sumValue = 0;
      var startValue = 0;
      var endValue = 0;
      var legendData = [];
      var k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3;
      // 为每一个饼图数据，生成一个 series-surface 配置
      for (var i = 0; i < pieData.length; i++) {
        sumValue += pieData[i].value;
        var seriesItem = {
          name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k: k
          }
        };
        if (typeof pieData[i].itemStyle != 'undefined') {
          var itemStyle = {};
          typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
          typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;
          seriesItem.itemStyle = itemStyle;
        }
        series.push(seriesItem);
      }
      let morList = []
      for (var i = 0; i < series.length; i += 1) {
        morList.push(series[i].pieData.value)
      }
      morList = morList.map(value => (typeof value === 'string' ? parseFloat(value) : value));
      let itMax = this.data_max||10;
      let is_fixedHeight = this.fixed_height;
      if(!is_fixedHeight){
        let maxValue = Math.max(...morList);
        morList = morList.map(value => value * (itMax / maxValue));
      }
      // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
      // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
      for (var i = 0; i < series.length; i++) {
        endValue = startValue + series[i].pieData.value;
        series[i].pieData.startRatio = startValue / sumValue;
        series[i].pieData.endRatio = endValue / sumValue;
        series[i].parametricEquation = this.getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, false, k, is_fixedHeight?itMax:morList[i]);
        startValue = endValue;
        legendData.push(series[i].name);
        // 判断增加 label 效果 @20210613
        pieData[i].label = { show: true }
        if (pieData[i].label && pieData[i].label.show) {
          let labelRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI;
         let dlabel =  mixinCopyData(labelSeries.label);
         dlabel.distance=is_fixedHeight?this.label_distance:(morList[i]*this.label_distance/this.box_height);
          labelSeries.data.push({
            name: this.getLabelFormatter(series[i].name,Number(series[i].pieData.value),sumValue),
            value: [Math.cos(labelRadian), Math.sin(labelRadian), 1.2, Number(series[i].pieData.value)],
            itemStyle: {
              opacity: 1,
            },
            label:dlabel
          })
        }
      }
      series.push(labelSeries)
      // // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
      if(!this.hidden_base){
        series.push({
          name: '',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          itemStyle: {
            opacity: 0.1,
            color: '#E1E8EC',
          },
          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20,
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20,
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 2;
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 2;
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? -0.5 : -5;
            },
          },
        });
        series.push({
          name: '',
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false,
          },
          itemStyle: {
            opacity: 0.1,
            color: '#E1E8EC',
          },
          parametricEquation: {
            u: {
              min: 0,
              max: Math.PI * 2,
              step: Math.PI / 20,
            },
            v: {
              min: 0,
              max: Math.PI,
              step: Math.PI / 20,
            },
            x: function (u, v) {
              return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * 2.2;
            },
            y: function (u, v) {
              return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * 2.2;
            },
            z: function (u, v) {
              return Math.cos(v) > 0 ? -7 : -7;
            },
          },
        });
      }
      return series;
    },
    getLabelFormatter(name, value, totalValue) {
      let formatter = this.chartOption.labelSetting.threeDimLabel.formatter || '{b}'
      let percentage = ((value / totalValue) * 100).toFixed(2);
      let result = ''
      switch (formatter) {
        case '{b}':
          result = name
          break
        case '{c}':
          result = value
          break
          case '{d}%':
          result = value
          break
          case '{b}: {c}':
          result = `${name}: ${value}`
          break
          case '{b}: {d}%':
          result = `${name}: ${percentage}%`
          break
          case '{b}: {c} {d}%':
          result = `${name}: ${value} ${percentage}%`
          break
      }
      return result;
    },
  },
}
// 3D漏斗
var benbenThreeDimensionalFunnel = {
  template: ` <div id="app" class="hopper-box">
  <div class="hopper-center">
    <template v-for="(item,i) in dataArr">
      <div v-if="item.isShow" :key="i" class="hopper-item">
        <div :style="item.styleInfo" class="hopper-picture">
          <div class="item-name">
            <div class="item-line"></div>
            <span>{{item.name}}:{{item.value}}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
  <div>
    <div class="hopper-legend">
      <span
        @click="item.isShow=!item.isShow"
        v-for="(item,i) in dataArr"
        :key="i"
      >
        <i :style="{'background-color': item.isShow?item.color:'#eee'}"></i>
        {{item.name}}
      </span>
    </div>
  </div>
</div>`,
  name: 'benben-three-dimensional-funnel',
  data() {
    return {
      cId: '',
      chart: null,
      dataInfo: [
        { value: 100, name: "线索" },
        { value: 90, name: "有效" },
        { value: 80, name: "意向" },
        { value: 70, name: "重点" },
        { value: 60, name: "准客户" },
        { value: 50, name: "成交" },
      ],
      dataArr: [],
    }
  },
  props: {
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () =>{},
    },
    data_source_field_name: {
      type: Object,
      default: () =>{},
    },
   
    theme_color: {
      type: Array,
      default: () =>[],
    },
    linear_gradient_color: {
      type: Array,
      default: () =>[],
    },
    chartOption: {
      type: Object,
      default:() => {
      },
    },
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    getDataArr() {
      let colorArr= themeColor(this.theme_color)
      if (!this.dataInfo.length || !colorArr.length) {
        this.dataArr = [];
        return;
      }
      let maxNum = Math.sqrt(
        Math.max(...this.dataInfo.map((item) => item.value))
      );
      let colorIndex = 0;
      this.dataArr = this.dataInfo
        .map((item) => {
          let color = colorArr[colorIndex];
          if (colorArr[colorIndex + 1]) colorIndex++;
          else colorIndex = 0;
          color = normalizeColor(color)
          let colorInfo = this.getBrighterAndDarkerColors(color, 0.25);
          return {
            ...item,
            isShow: true,
            color,
            styleInfo: `--bg-color:${color};width:${
              (Math.sqrt(item.value) / maxNum) * 100
            }%; --dark-color:${colorInfo.brighter};--light-color:${
              colorInfo.darker
            };`,
          };
        })
        .sort((a, b) => b.value - a.value);
    },
    getBrighterAndDarkerColors(hexColor, factor) { 
      // 将16进制颜色值转换为RGB数组
      const rgbColor = this.hexToRgb(hexColor);
      // 获取亮度更高的颜色
      const brighterRGB = rgbColor.map((channel) =>
        Math.min(255, Math.round(channel + factor * 255))
      );
      // 获取亮度更低的颜色
      const darkerRGB = rgbColor.map((channel) =>
        Math.max(0, Math.round(channel - factor * 255))
      );
      // 转换RGB数组为16进制颜色值
      const brighterHex = this.rgbToHex(brighterRGB);
      const darkerHex = this.rgbToHex(darkerRGB);
      // 返回结果
      return {
        brighter: brighterHex,
        darker: darkerHex,
      };
    },
    hexToRgb(hexColor) {
      const hex = hexColor.replace(/^#/, "");
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return [r, g, b];
    },
    rgbToHex(rgbColor) {
      return (
        "#" +
        rgbColor
          .map((channel) => channel.toString(16).padStart(2, "0"))
          .join("")
      );
    },
    renderChart() {
      if (this.data_source_type == '1') {
        this.dataInfo = this.fieldOptions.series[0].data;
      } else if (this.data_source_type == '2') {
        this.dataInfo = this.data_source_field_name.chart_data || []
      }
      this.getDataArr();
    },
  },
}
// 3d词云
var wordCloud = {
  template: ` <div ref="wordCloudDiv" :style="{width:widthStyle,height:heightStyle}">
  <svg v-if="tags.length"
    :width="copywidth"
    :height="copyheight"
    @mousemove="listener($event)"
    @mouseout="listener1($event)"
    @mouseover="listener2($event)"
  >
    <a href="#" v-for="(tag, index) in tags" :key="index" @click="showOptionsAndResult(tag.url)">
      <text
        :x="tag.x" :y="tag.y"
        :font-size="fontSize * (1000 / (800 - tag.z * 2))"
        :font-weight="550"
        :fill-opacity="(600 + tag.z) / 800"
        :style="style(tag)">{{ tag.name }}</text>
    </a>
  </svg>
</div>`,
  name: 'word-cloud',
  data() {
    return {
      speedX: Math.PI / 1800,
      speedY: Math.PI / 1800,
      tags:[],
      CXNum: 2,
      CYNum: 2,
      copyheight: this.height,
      copywidth: this.width,
      is_load:false
    }
  },
  props: {
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () =>{},
    },
    data_source_field_name: {
      type: Object,
      default: () =>{},
    },
   
    theme_color: {
      type: Array,
      default: () =>[],
    },
    linear_gradient_color: {
      type: Array,
      default:() =>[],
    },
    chartOption: {
      type: Object,
      default: () =>{
      },
    },
    width: {
      type: [Number,String],
      default: 800,
    },
    height: {
      type: [Number,String],
      default: 600,
    },
    radius :{
      type: Number,
      default: 100,
    },
    fontSize:{
      type: Number,
      default: 16,
    },
    speed:{
      type: Number,
      default: 30,
    }
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval && this.is_load) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval && this.is_load) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    CX() {
      return this.copywidth / this.CXNum
    },
    CY() {
      return this.copyheight / this.CYNum
    },
    widthStyle(){
      let width = this.width;
      return typeof width == 'number'?width+'px':width
    },
    heightStyle(){
      let height = this.height;
      return typeof height == 'number'?height+'px':height
    },
  },
  methods: {
    getHeightAfterUpdate() {
      var that = this;
      const div = this.$refs.wordCloudDiv; // 获取ref绑定的DOM元素
      Vue.nextTick(() => { // 确保DOM更新完成后再获取高度值
        that.copyheight = div.offsetHeight; // 获取高度（不包括边框）
        that.copywidth = div.offsetWidth;
        that.is_load = true;
        that.renderChart();
      });
    },
    renderChart() {
      let dataInfo = []
      if (this.data_source_type == '1') {
        dataInfo = this.fieldOptions.series;
      } else if (this.data_source_type == '2') {
        dataInfo = this.data_source_field_name.chart_data || []
      }
      this.setTags(dataInfo)
      setInterval(() => {
        this.rotateX(this.speedX)
        this.rotateY(this.speedY)
      }, this.speed)
    },
    rotateX(angleX) {
      var cos = Math.cos(angleX)
      var sin = Math.sin(angleX)
      for (let i = 0; i < this.tags.length; i++) {
        let tag = this.tags[i]
        var y1 = (tag.y - this.CY) * cos - tag.z * sin + this.CY
        var z1 = tag.z * cos + (tag.y - this.CY) * sin
        tag.y = y1
        tag.z = z1
      }
    },
    rotateY(angleY) {
      var cos = Math.cos(angleY)
      var sin = Math.sin(angleY)
      for (let tag of this.tags) {
        var x1 = (tag.x - this.CX) * cos - tag.z * sin + this.CX
        var z1 = tag.z * cos + (tag.x - this.CX) * sin
        tag.x = x1
        tag.z = z1
      }
    },
    listener(event) {
      var x = event.clientX - this.CX
      var y = event.clientY - this.CY
      this.speedX =
        x * 0.0001 > 0 ? Math.min(this.radius * 0.00002, x * 0.0001) : Math.max(-this.radius * 0.00002, x * 0.0001)
      this.speedY =
        y * 0.0001 > 0 ? Math.min(this.radius * 0.00002, y * 0.0001) : Math.max(-this.radius * 0.00002, y * 0.0001)
    },
    listener1(e) {
      this.speedX = Math.PI / 1800
      this.speedY = Math.PI / 1800
    },
    listener2(e) {
      this.speedX = 0
      this.speedY = 0
    },
    showOptionsAndResult(url) {
     if(url){
        window.open(url)
     }
    },
    style(tag) {
      return `fill:${tag.color};`
    },
    calculation3DWord(radius = '') {
      let tags = []
      let chartThemeColor = themeColor(this.theme_color)
      for (let i = 0; i < this.tags.length; i++) {
        let tag = {}
        let k = -1 + (2 * (i + 1) - 1) / this.tags.length
        let a = Math.acos(k)
        let b = a * Math.sqrt(this.tags.length * Math.PI)
        tag.name = typeof this.tags[i] === 'string' ? this.tags[i] : this.tags[i].name
        if (radius === '') {
          tag.x = this.CX + this.radius * Math.sin(a) * Math.cos(b)
          tag.y = this.CY + this.radius * Math.sin(a) * Math.sin(b)
          tag.z = this.radius * Math.cos(a)
        } else {
          tag.x = 150 * (radius / 120) + radius * Math.sin(a) * Math.cos(b)
          tag.y = 150 * (radius / 120) + radius * Math.sin(a) * Math.sin(b)
          tag.z = radius * Math.cos(a)
        }
        if (i <= chartThemeColor.length - 1) {
          tag.color = chartThemeColor[i]
        } else {
          tag.color = i % chartThemeColor.length === 0 ? chartThemeColor[0] : chartThemeColor[i % chartThemeColor.length]
        }
        tags.push(tag)
      }
      this.tags.splice(0)
      this.tags = tags
    },
    setTags(tags = []) {
      this.tags.splice(0)
      this.tags.push(...tags)
      this.calculation3DWord()
    },
  },
  created(){
    var that = this;
    this.$nextTick(() => {
      that.getHeightAfterUpdate();  
    });
  }
}
// 3D地球飞线
var benbenGlobleLineMap = {
  name: 'benben-globle-line-map',
  data() {
    return {
      options: {},
    }
  },
  props: {
    globle_mode: {
      type: String,
      default: 'seaBlue',
    }
  },
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.cId))
      if (this.data_source_type == '1') {
        this.commonInit(this.fieldOptions);
        this.chart.setOption(this.options)
      }else if(this.data_source_type == '2'){
        this.commonInit(this.data_source_field_name);
        this.chart.setOption(this.options)
      }
    },
    commonInit(dataObj) {
      var baseTextureUrl = 'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231125/5ebae17598b4eae5257a2e44072754c3.jpg';
      if (this.globalMode == "seaBlue") {
        baseTextureUrl = 'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231125/5ebae17598b4eae5257a2e44072754c3.jpg';
      } else if (this.globalMode == "lightBlue") {
        baseTextureUrl = 'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231125/cd33d1f3eedb84298f9e874b4accbb43.jpg';
      } else if (this.globalMode == "terrain") {
        baseTextureUrl = 'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231125/7949d2d0e455d8324817cd32a04d6820.jpg';
      }
      this.options = {
        globe: {
          environment: 'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231125/aeaf4baf39d92959fd8df932680d0583.jpg',
          heightTexture: '',
          baseTexture: baseTextureUrl, // 地球表面覆盖的图片
          shading: 'lambert', // 地球中三维图形的着色效果
          zoom: 90,
          viewControl: {
            autoRotate: true, // 自动旋转
            autoRotateSpeed: 3, //物体自转的速度,单位为角度 / 秒，默认为10也就是36秒转一圈。
            autoRotateAfterStill: 2, // 在鼠标静止操作后恢复自动旋转的时间间隔,默认 3s
            rotateSensitivity: 2, // 旋转操作的灵敏度，值越大越灵敏.设置为0后无法旋转。[1, 0]只能横向旋转.[0, 1]只能纵向旋转
            targetCoord: dataObj.targetData.lat, // 定位到目标
            maxDistance: 300,
            minDistance: 200
          },
          atmosphere: {
            show: true // 开启大气层光圈
          }
        },
        series: [{
          name: "lines3D",
          type: "lines3D",
          coordinateSystem: "globe",
          effect: {
            show: true,
          },
          // blendMode: "lighter",
          lineStyle: {
            color: '#fff',
            width: 1,
          },
          data: [],
          silent: false,
        },],
      }
      let seriesData =  dataObj.sourceData.map((item,index)=>{
      return {coords:[dataObj.targetData.lat,item.lat],value:''}
    })
    this.options.series[0].data  = seriesData
    }
  },
}
//时间
var benbenRealTime = {
  template: `<div class="benben-real-time"> 
        <span v-if="date_obj.day"><span>{{date_obj.day}}</span> <span v-if="has_week">星期{{date_obj.week}}</span></span>
        </div>`,
  name: 'benben-real-time',
  data() {
    return {
      date_obj: { day: '', week: '' },
      progressTimer: null,
    }
  },
  props: {
    has_week: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss',
    },
    refresh_interval: {
      type: Number,
      default: 500,
    },
  },
  mounted() {
    this.refresh_Data()
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  },
  methods: {
    refresh_Data() {
      var that = this
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      this.progressTimer = setInterval(function () {
        var now = new Date()
        that.date_obj.day = moment(now.getTime()).format(that.format)
        if (that.has_week) {
          var nowDayOfWeek = now.getDay() //今天本周的第几天
          that.date_obj.week = ['日', '一', '二', '三', '四', '五', '六'][nowDayOfWeek]
        }
      }, this.refresh_interval)
    },
  },
}
// 关系树
var benbenRelationGraph = {
  template: `<div @click.self="handleClick" class="benben-relation-graph" style="position: relative;"> 
        <div v-if="show_title=='true'" class="chart-title"  @click="handleClick"  :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{ title_name }}</div>
        <iframe ref="Frame" class="frame" frameborder="0"></iframe>
        <relation-graph v-if="showRelation" ref="RelationGraph" :on-node-expand="onNodeExpand"  :options="graphOptionsFunc(tree_position_result)" />
        </div>`,
  name: 'benben-relation-graph',
  components: { RelationGraph },
  data() {
    return {
      newJsonData: {
        rootId: '',
        nodes: [],
        links: []
      },
      showRelation: false,
    }
  },
  props: {
    show_title: {
      type: String,
      default: "true",
    },
    title_position: {
      type: String,
      default: 'middle',
    },
    title_name: {
      type: String,
      default: '标题',
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () =>{},
    },
    data_source_field_name: {
      type: Object,
      default: () =>{},
    },
    theme_color: {
      type: Array,
      default: () =>[],
    },
    options: {
      type: Object,
      default: () => ({})
    },
    tree_position: {
      type: String,
      default: 'left',
    },
    relation_expanded: {
      type: String,
      default: '3',
    },
    chartOption: {
      type: Object,
      default: {
      },
    },
   
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.createRelationGraph()
          })
        }
      },
      immediate: true,
      deep: true,
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.createRelationGraph()
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    tree_position_result() {
      return this.tree_position
    },
  },
  created() {
  },
  mounted() {
    this.showRelation = true
    this.$nextTick(() => {
      this.createRelationGraph()
      this.$refs['Frame'].contentWindow.addEventListener('resize', this.resize)
    })
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
    createRelationGraph() {
      let dataInfo = null;
      if (this.data_source_type == '1') {
        dataInfo = this.fieldOptions;
      } else if (this.data_source_type == '2') {
        dataInfo = this.data_source_field_name
      }
      if(!dataInfo){return}
      var newJsonData = this.getJsonData(dataInfo, '', this.relation_expanded - 1)
      var that = this;
      this.$refs['RelationGraph'].setOptions(that.graphOptionsFunc(that.tree_position_result), (graphInstance) => {
        graphInstance.setJsonData(newJsonData, (data) => { })
      });
    },
    graphOptionsFunc(tree_position) {
      var graphOptions = {
        debug: false,
        allowShowMiniToolBar: true,
        moveToCenterWhenResize: true,
        disableZoom: false,
        'layouts': [
          {
            'layoutName': 'tree',
            'layoutClassName': 'seeks-layout-center',
            'defaultJunctionPoint': 'border',
            'defaultNodeShape': 0,
            'defaultLineShape': 1,
            'from': 'left',
            'min_per_width': '160',
            'min_per_height': '10',
          }
        ],
        'defaultLineMarker': {
          'markerWidth': 12,
          'markerHeight': 12,
          'refX': 6,
          'refY': 6,
          'data': 'M2,2 L10,6 L2,10 L6,6 L2,2'
        },
        'defaultExpandHolderPosition': 'right',
        'defaultNodeShape': 1,
        'defaultNodeWidth': '90',
        'defaultLineShape': 4,
        'defaultJunctionPoint': 'lr',
        'defaultNodeBorderWidth': 0,
        'defaultLineColor': '#409EFF',
        'defaultNodeColor': '#409EFF'
      }
      if(tree_position === 'top'){
        graphOptions.layouts[0].from = 'top'
        graphOptions.layouts[0].min_per_width = '10'
        graphOptions.layouts[0].min_per_height = '10'
        graphOptions.defaultExpandHolderPosition = 'bottom'
        graphOptions.defaultNodeWidth = 70;
        graphOptions.defaultJunctionPoint = 'tb'
      }else if(tree_position === 'left'){
        graphOptions.layouts[0].from = 'left'
        graphOptions.layouts[0].min_per_width = '160'
        graphOptions.layouts[0].min_per_height = '10'
        graphOptions.defaultExpandHolderPosition = 'right'
        graphOptions.defaultJunctionPoint = 'lr'
      }
      return graphOptions
    },
    // 转换数据
    getJsonData(data, title, expandedNumber) {
      if (Array.isArray(data)) data = { id: 'root', text: title, children: JSON.parse(JSON.stringify(data)) }
      var newJsonData = {
        rootId: '',
        nodes: [],
        links: []
      }
      this.formatData(data, expandedNumber, 0, newJsonData)
      return newJsonData
    },
    formatData(obj, expandedNumber, currentIndex, newJsonData) {
      var { children = [], name, pid, aid } = obj
      if (pid === 0) newJsonData.rootId = aid.toString()
      var expanded = currentIndex < expandedNumber;
      var maringObj = { id: aid.toString(), text: name, expanded }
      if (!expanded) maringObj.data = { isNeedLoadDataFromRemoteServer: false, childrenLoaded: false }
      newJsonData.nodes.push(maringObj)
      if (children.length) {
        newJsonData.links.push(...children.map(v => ({ from: aid.toString(), to: v.aid.toString() })))
        children.forEach((v, i) => this.formatData(obj.children[i], expandedNumber, currentIndex + 1, newJsonData))
      }
    },
    resize() {
      setTimeout(() => this.$refs['RelationGraph'].refresh())
    },
    onNodeExpand(node, e) {
      // 根据具体的业务需要决定是否需要从后台加载数据
      if (!node.data.isNeedLoadDataFromRemoteServer) {
        // this.$refs['RelationGraph'].refresh();
        return;
      }
    }
  },
  beforeDestroy() {
    this.$refs['Frame'].contentWindow.removeEventListener('resize',this.resize)
  },
}
//倒计时
var benbenCountDown = { 
  template: `<div @click.self="handleClick" class="benben-count-down"> 
        <span v-if="only_day&&show" >{{date_obj.dd}} 天</span>
        <span v-else-if="show">{{date_obj.dd}}<span>天</span><span>{{date_obj.hh}}</span><span>时</span><span>{{date_obj.mm}}</span><span>分</span><span>{{date_obj.ss}}</span><span>秒</span></span>
        </div>`,
  name: 'benben-count-down',
  data() {
    return {
      date_obj: { dd: '', hh: '', mm: '', ss: '', run: true },
      show: false,
      progressTimer: null,
    }
  },
  props: {
    only_day: {
      type: Boolean,
      default: false,
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: {},
    },
  },
  mounted() {
    if (this.data_source_type == 1 && this.fieldOptions && this.fieldOptions.data) {
      this.refresh_Data(this.fieldOptions.data)
    }
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
    refresh_Data(data) {
      var that = this
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      if (that.date_obj.run) {
        that.show = true
        that.progressTimer = setInterval(function () {
          that.date_obj = countDownFn(data)
          if (!that.date_obj.run) {
            clearInterval(that.progressTimer)
            that.progressTimer = null
          }
        }, 1000)
      } else {
        clearInterval(that.progressTimer)
        that.progressTimer = null
      }
    },
  },
}
// 滚动文本
var benbenSimpleText = {
  template: `<div  @click.self="handleClick" class="benben-simple-text" style="position: relative;"> 
        <div v-if="show_title=='true'" class="chart-title"  @click="handleClick" :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{ title_name }}</div>
        <div v-if="currentText" :style="{'--benben-animation-timer':simple_text_animation + 's'}"  :class="[show_title === 'true' ? 'content-body' : 'content-body-no-title']" >{{ displayedText }}</div>
        </div>`,
  name: 'benben-simple-text',
  mixins:[mixinsBaseProps],
  data() {
    return {
      currentText: '',
      currentIndex:0,
    }
  },
  props: {
    data_source_field: {
      type: String,
      default: 'number',
    },
    simple_text_animation:{
      type:Number,
      default:3
    }
  },
  computed: {
    displayedText() {
      // 判断传入的数据类型是字符串还是数组
      if (Array.isArray(this.currentText)) {
        return this.currentText[this.currentIndex];
      } else {
        return this.currentText;
      }
    }
  },
  methods: {
    renderChart() {
      if (this.data_source_type == 1) {
        this.currentText = this.fieldOptions.data;
      } else if (this.data_source_type == 2) {
        this.currentText = this.data_source_field_name[this.data_source_field]
      }
      this.startTextAnimation();
    },
    startTextAnimation() {
      setInterval(() => {
        // 如果数据是数组，更新当前索引
        if (Array.isArray(this.currentText)) {
          this.currentIndex = (this.currentIndex + 1) % this.currentText.length;
        }
      }, this.simple_text_animation * 1000);
    }
  },
}
//数字卡片
var benbenNumberCard = {
  template: `<div @click.self="handleClick" class="benben-number-card"> 
         <div v-if="!isEmpty(numData)&&numData.length" style="display: flex;justify-content: center;align-items: center;"><div class="flip-single-number" :style="{'border-image-source':'var(--border-image, url('+global_web_url_oss+'/m2785/border-17.gif?x-oss-process=image/resize,m_lfit,w_440/format,gif))'}"  v-for="(item, index) in numData.length" :key="index">{{ numData[index] }}</div></div>
        </div>`,
  name: 'benben-number-card',
  data() {
    return {
      numData: '',
      unit:'',
      show: false,
    }
  },
  mixins:[mixinsBaseProps],
  props: {
    data_source_field: {
      type: String,
      default: 'number',
    },
    is_abs: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    renderChart() {
      var numData = '',num_unit=""
      if (this.data_source_type == 1 && this.fieldOptions && this.fieldOptions.data) {
        numData = this.fieldOptions.data
      } else if (this.data_source_type == 2) {
        numData = this.data_source_field_name[this.data_source_field]
      }
      if(this.is_abs){numData=Math.abs(numData)}
      if(isEmpty(numData)) return 
      this.numData = numData+''
      num_unit&&(this.numData+=num_unit)
    },
  },
}
//数字
var benbenNumberBlock = {
  template: `<div @click.self="handleClick" class="benben-number-block" style="position: relative;"> 
        <div v-if="show_title=='true'" class="chart-title"  @click="handleClick"  :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{ title_name }}</div>
        <div v-if="!isEmpty(numData)" style="display: flex;justify-content: center;align-items: center;" :class="show_title=='true'?'flip-number-block':'flip-number-block-no-title'">
          <span class="num">{{ numData }}</span>  <span class="unit">{{ num_unit }}</span>
        </div>
        </div>`,
  name: 'benben-number-block',
  data() {
    return {
      numData: '',
      num_unit:this.unit,
      show: false,
    }
  },
  mixins:[mixinsBaseProps],
  props: {
    data_source_field: {
      type: String,
      default: 'number',
    },
    is_abs: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isEmpty,
    renderChart() {
      var numData = '',num_unit=""
      if (this.data_source_type == 1 && this.fieldOptions && this.fieldOptions.data) {
        numData = this.fieldOptions.data
      } else if (this.data_source_type == 2) {
        numData = this.data_source_field_name[this.data_source_field]
      }
      if(this.is_abs){numData=Math.abs(numData)}
      if(isEmpty(numData)) return
      this.numData = numData;
      num_unit&&(this.num_unit = num_unit)
    },
  },
}
// 发光数字
var benbenLightText = {
  template: `<span  @click.self="handleClick" class="benben-light-text light-text" > 
  {{ numData }}</span>`,
  name: 'benben-light-text',
  data() {
    return {
      numData: ''
    }
  },
  mixins:[mixinsBaseProps],
  props: {
    is_abs: {
      type: Boolean,
      default: false,
    },
    data_source_field: {
      type: String,
      default: 'number',
    }
  },
  methods: {
    renderChart() {
      var numData = '',num_unit=""
      if (this.data_source_type == 1) {
        numData = this.fieldOptions.data;
      } else if (this.data_source_type == 2) {
        numData = this.data_source_field_name[this.data_source_field]
      }
      this.$emit('update:report_value',numData)
      if(this.is_abs){numData=Math.abs(numData)}
      if(isEmpty(numData)) return
      this.numData = numData
      num_unit&&(this.numData+=num_unit)
    }
  },
}
//单数字法光
var benbenSingleLightText = {
  template: `<div @click.self="handleClick" class="benben-single-light-text"> 
      <div v-if="!isEmpty(numData)&&numData.length" style="display: flex;justify-content: center;align-items: center;">
        <div v-for="(item, index) in numData.length" :key="index" class="single-light-number-mor"
          :class="numData[index] == ',' || numData[index] == '.' ? 'single-light-thousands-separator' : ''">
          {{ numData[index] }}
        </div>
      </div>
         </div>`,
  name: 'benben-single-light-text',
  data() {
    return {
      numData: '',
      show: false,
    }
  },
  mixins:[mixinsBaseProps],
  props: {
    show_thousands_separator: {
      type: String,
      default: 'true',
    },
    decimal_places: {
      type: String,
      default: '1',
    },
    data_source_field: {
      type: String,
      default: 'number',
    },
    is_abs: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isEmpty,
    renderChart() {
      var numData = '',num_unit=""
      if (this.data_source_type == 1) {
        numData = this.fieldOptions.data
      } else if (this.data_source_type == 2) {
        numData = this.data_source_field_name[this.data_source_field]
      }
      this.$emit('update:report_value',numData)
      if(this.is_abs){numData=Math.abs(numData)}
      if(isEmpty(numData)) return
      if (!/^\d+(\.\d+)?$/.test(numData)) {
        this.numData = numData+''
      }else{
        this.numData = this.getNumberResult(numData)+''
      }
      num_unit&&(this.numData +=num_unit)
    },
    getNumberResult(data) {
      var beforeNum = this.getIntegerResult(data),afterNum=''
      if(this.show_thousands_separator){
        beforeNum = beforeNum.toLocaleString()
      }
      if(this.decimal_places > 0){
        afterNum = '.' + this.getDecimalResult(data)
      }
      return beforeNum + afterNum
    },
    getDecimalResult(data) {
      var wit = this.decimal_places;
      var decimalPart = String(data).split('.')[1] || '';
      if (decimalPart.length > wit) {
        decimalPart = decimalPart.substring(0, wit);
      } else if (decimalPart.length < wit) {
        // 补 0
        decimalPart = decimalPart.padEnd(wit, '0');
      }
      return decimalPart;
    },
    getIntegerResult(data) {
      var integerPart = String(data).split('.')[0] || '';
      return Number(integerPart);
    },
  },
}
//数字翻牌器
var benbenNumberFlipper = {
  template: `<div @click.self="handleClick" class="benbenNumberFlipper"> 
  <div v-if="!isEmpty(numData)&&numData.length" style="display: flex;justify-content: center;align-items: center;">
  <div v-for="(item, index) in numData.length" :key="index" class="flipper-single-number-mor"
    :class="numData[index] == ',' || numData[index] == '.' ? 'flipper-single-thousands-separator' : ''">
    {{ numData[index] }}
  </div>
</div>
         </div>`,
  name: 'benben-number-flipper',
  data() {
    return {
      numData: '',
      show: false,
    }
  },
  mixins:[mixinsBaseProps],
  props: {
    show_thousands_separator: {
      type: String,
      default: 'true',
    },
    decimal_places: {
      type: String,
      default: '1',
    },
    data_source_field: {
      type: String,
      default: 'number',
    },
    is_abs: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isEmpty,
    renderChart() {
      var numData = '',num_unit=""
      if (this.data_source_type == 1) {
        numData = this.fieldOptions.data
      } else if (this.data_source_type == 2) {
        numData = this.data_source_field_name[this.data_source_field]
      }
      if(this.is_abs){numData=Math.abs(numData)}
      if(isEmpty(numData)) return
      this.numData = this.getNumberResult(numData);
      num_unit&&(this.numData += num_unit)
    },
    getNumberResult(data) {
      var beforeNum = this.getIntegerResult(data),afterNum=''
      if(this.show_thousands_separator){
        beforeNum = beforeNum.toLocaleString()
      }
      if(this.decimal_places > 0){
        afterNum = '.' + this.getDecimalResult(data)
      }
      return beforeNum + afterNum
    },
    getDecimalResult(data) {
      var wit = this.decimal_places;
      var decimalPart = String(data).split('.')[1] || '';
      if (decimalPart.length > wit) {
        decimalPart = decimalPart.substring(0, wit);
      } else if (decimalPart.length < wit) {
        // 补 0
        decimalPart = decimalPart.padEnd(wit, '0');
      }
      return decimalPart;
    },
    getIntegerResult(data) {
      var integerPart = String(data).split('.')[0] || '';
      return Number(integerPart);
    },
  },
}
// 排行榜
var bigScreenRank = {
  template: `<div @click.self="handleClick" class="big-screen-rank"  style="position: relative;"> 
  <div  v-if="show_title=='true'" class="chart-title"   @click="handleClick" :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{ title_name }}</div>
  <div :class="show_title=='true'?'scrollbar-container':'scrollbar-container-no-title'" class=" ps ps--theme_default" :style="{height:26*(show_num+1)+4+'px'}">
    <div class="ranking ranking-table" style="height:100%"  v-if="chartData&&chartDataRows&&chartDataRows&&chartDataRows.length">
        <div class="ranking-col" v-for="(citem,cidx) in chartDataColumns" :key="cidx" style="text-align: left; background: transparent; flex-grow: 1; width: auto;">
          <template v-if="cidx==0">
            <div class="ranking-cell ranking-head table-ranking-header-bg"
              style="padding: 4px 6px;">
              <div class="ranking-text-ellipsis">{{num_name}}</div>
            </div>
            <div style="width:100%;">
            <div class="ranking-container"  :class="chartDataRows.length>5?'bounce-leave-to bounce-enter bounce-enter-active':''">
              <div class="ranking-cell" v-for="(item,idx) in chartDataRows" :key="cidx+'_'+idx" style="padding: 0px 6px;  height: 26px;
              line-height: 26px; position: relative;" :class="{'table-ranking-line-odd':idx%2==0,'table-ranking-line-even':idx%2!=0}">
                <div class="ranking-text-ellipsis" v-if="item.sort<=3">
                  <span class="ranking-rank ranking-icon" 
                  :style="{background:'url('+global_web_url_oss+'/m2785/rank_custom.png)  no-repeat','background-position': -15*(item.sort-1)+'px 0px  !important', 'background-size': '182.25px !important'}" style="width: 14px; height: 14px;"></span>
                </div>
                <div class="ranking-text-ellipsis ranking-value" style="width: 15px;height: 18px;line-height: 18px; " v-if="item.sort>3"><span class="ranking-rank table-ranging-sort-color"
                    style="width: 15px; " :style="{'color':sort_other_color||calculateThemeColor(item.sort-1)}">{{item.sort}}</span></div>
              </div>
              </div>
            </div>
          </template>
          <template v-if="cidx>0">
            <div class="ranking-col" style="text-align: left; background: transparent; flex-grow: 1; width: auto;">
                <div class="ranking-cell ranking-head table-ranking-header-bg" style="padding: 4px 6px; ">
                    <div class="ranking-text-ellipsis">{{ citem.name }}</div>
                </div>
                <div style="width:100%;">
                <div class="ranking-container ranking-change-container" v-for="(item,idx) in chartDataRows" :key="cidx+'_'+idx" :class="{'table-ranking-line-odd':idx%2==0,'table-ranking-line-even':idx%2!=0,'bounce-leave-to bounce-enter  bounce-enter-active':chartDataRows.length>5}" style="justify-content: flex-start; color: rgb(255, 255, 255);">
                    <div class="ranking-sub-col ranking-text-ellipsis">
                    <div class="ranking-cell ranking-value"
                        style="padding: 0px 0px 0px 6px;height: 26px;display: flex;
                        align-items: center; ">{{item[citem.prop]}}</div>
                    </div>
                </div>
                </div>
            </div>
          </template>
        </div>
    </div>
  </div>
  </div>`,
  name: 'big-screen-rank',
  data() {
    return {
      chartData: null,
      show: false,
      progressTimer: null,
      chartDataRows: [],
      tableData: {}
    }
  },
  props: {
    show_title: {
      type: String,
      default: "true",
    },
    title_position: {
      type: String,
      default: 'middle'
    },
    title_name: {
      type: String,
      default: '标题'
    },
    num_name: {
      type: String,
      default: '序号'
    },
    data_source_type: {
      type: String,
      default: '1'
    },
    fieldOptions: {
      type: Object,
      default: {}
    },
    data_source_field_name: {
      type: Object,
      default: {}
    },
    play_type: {
      type: String,
      default: ""
    },
    show_num: {
      type: Number,
      default: 5
    },
    sort_order: {
      type: String,
      default: 'desc',
    },
    sort_other_color: {
      type: String,
      default: '',
    },
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    chartDataColumns() {
      var columns = this.chartData.table_title || this.chartData.columns
      return [{ name: "排序" }, ...columns]
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
    renderChart() {
      if (this.data_source_type == 1) {
        this.chartData = this.fieldOptions
      } else if (this.data_source_type == 2) {
        this.chartData = this.data_source_field_name
      }
      if (!isEmpty(this.chartData)) {
        this.chartDataRows = this.chartData.table_data || this.chartData.rows
        this.chartDataRows.forEach((item, index) => { item.sort = index + 1 })
        if (this.chartDataRows.length > this.show_num && this.play_type != "none") {
          this.refresh_Data()
        } else {
          if (this.progressTimer) {
            clearInterval(this.progressTimer)
            this.progressTimer = null
          }
        }
      }
    },
    refresh_Data() {
      var that = this
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      setTimeout(() => {
        that.progressTimer = setInterval(function () {
          var data_item = that.chartDataRows.shift()
          that.chartDataRows.push(data_item)
        }, 2000)
      })
    },
    calculateThemeColor(index) {
      let chartThemeColor = themeColor(this.theme_color);
      if(!chartThemeColor.length){ return '#69EEFF'}
      let colorIndex = index % chartThemeColor.length;
      colorIndex = this.sort_order === 'asc'? (chartThemeColor.length - 1 - colorIndex):colorIndex
      return chartThemeColor[colorIndex];
    },
  },
}
// 表格
var bigScreenTable = {
  template: `<div @click.self="handleClick" class="big-screen-table" style="position: relative"> 
        <div class="chart-title" v-if="show_title=='true'"  @click="handleClick"  :class="title_position=='middle'?'justify-center-chart':title_position=='right'?'justify-right-chart':'justify-left-chart'">{{ title_name }}</div>
        <div class="table-play-container chart_body" style="position: relative;" v-if="chartData">
        <div class="table-play-header table-play-header_bg" style="height: 40px; ">
          <div class="table-play-header-item" v-if="show_sort" style="font-size: 17px; width: 10%; text-align: center; text-overflow: ellipsis; white-space: nowrap;">{{num_name}}</div>
          <div class="table-play-header-item"  v-for="(item,idx) in chartData.columns" :key="idx" class=" table-play-header-item" :style="{width: ((show_sort?90:100)/(chartData.columns.length))+'%'}" style="font-size: 17px; text-align: center; text-overflow: ellipsis; white-space: nowrap;">{{ item.name }}</div>
        </div>
          <div class="table-play-body" style="margin-top: 40px; ">
            <div class="table-play-body-scroll" style="transition: top 1s linear 0s;" :style="{top: top+'px' }">
            <transition-group name="list" tag="div">
              <div v-for="(item,idx) in chartDataRows" :key="item.key"  :class="{'table-play-line-odd':item.sort%2==0,'table-play-line-even':item.sort%2!=0}"
              class="table-play-line table-dashboard" style="height:32px">
                <div class="table-play-line-item " style="width: 10%;" v-if="show_sort">
                  <div class="table-play-line-content table-play-sort" style="font-size: 13px; text-align: center; text-overflow: ellipsis; white-space: nowrap; width: 16px; height: 16px; line-height: 16px; transform: rotate(45deg); color: rgb(255, 255, 255); background-color: rgb(241, 70, 70);">
                    <div style="transform: rotate(-45deg);">{{ item.sort }}</div>
                  </div>
                </div>
                <div class="table-play-line-item" v-for="(citem,cidx) in chartData.columns" :key="cidx" :style="{width: ((show_sort?90:100)/(chartData.columns.length))+'%'}">
                 <div class="table-play-line-content" style="font-size: 13px; text-align: center; text-overflow: ellipsis; white-space: nowrap;" v-html="item[citem.prop]"></div>
                </div>
              </div>
              </transition-group>
          </div>
        </div>
        </div>
        </div>`,
  name: 'big-screen-table',
  data() {
    return {
      chartData: null,
      show: false,
      top: 0,
      progressTimer: null,
      chartDataRows: [],
      transkey: 0,
    }
  },
  props: {
    show_sort: {
      type: Boolean,
      default: true,
    },
    show_title: {
      type: String,
      default: "true",
    },
    title_position: {
      type: String,
      default: 'middle',
    },
    title_name: {
      type: String,
      default: '标题',
    },
    num_name: {
      type: String,
      default: '序号',
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    play_type: {
      type: String,
      default: '',
    },
    show_num: {
      type: Number,
      default: 5,
    },
    fieldOptions: {
      type: Object,
      default: {}
    },
    data_source_field_name: {
      type: Object,
      default: {}
    },
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart();
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  },
  methods: {
    handleClick($event) {
      this.$emit('click',$event)
    },
    renderChart() {
      if (this.data_source_type == 1) {
        this.chartData = this.fieldOptions
      } else if (this.data_source_type == 2) {
        this.chartData = this.data_source_field_name
      }
      if (!isEmpty(this.chartData)) {
        this.chartDataRows = this.chartData.table_data || this.chartData.rows
        this.chartDataRows.forEach((item, index) => {
          this.transkey = this.transkey + 1
          item.sort = index + 1
          item.key = this.transkey
        })
        if (this.chartDataRows.length > this.show_num && this.play_type != 'none') {
          this.refresh_Data()
        } else {
          if (this.progressTimer) {
            clearInterval(this.progressTimer)
            this.progressTimer = null
          }
        }
      }
    },
    refresh_Data() {
      var that = this
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      setTimeout(() => {
        that.progressTimer = setInterval(function () {
          var data_item = that.chartDataRows.shift()
          that.transkey = that.transkey + 1
          data_item.key = that.transkey
          that.chartDataRows.push(data_item)
        }, 5000)
      })
    },
  },
}
// 新自定义表格
var bigScreenCustomTable = {
  template: `<div ref="screen_custom_table"  class="big-screen-custom-table" :style="{'width':widthStyle,'height':heightStyle}"> 
  <div class="new-custom-table-container" v-if="chartData">
  <div class="new-custom-table-header custom-table-header-bg" :style=" {'height': (head_height+'px')}"
    v-if="show_header">
    <div  :style="{ width:sort_width+'%'}" style="text-align: center;text-overflow: ellipsis; white-space: nowrap;" v-if="sort_width">
      {{ sort_name }}</div>
    <div v-for="(citem, idx) in chartDataColumns" :key="idx" class=" new-custom-table-header-item" :class="citem.prop == sort_field&&show_progress?' t-lf':''"
      :style="{ width: ((100 - sort_width) / columns_length * columns_width(citem.prop)) + '%' }"
      style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden;">{{ citem.name }}</div>
  </div>
  <div class="new-custom-table-body" :style="{ 'margin-top': table_body_height.top,'height':table_body_height.height }">
    <div class="new-custom-table-body-scroll" :ref="'table-body-scroll'+cid" style="top: 0px;" :style="{ height: (row_height+row_gutter)*(show_num+1)+'px',transition:transition }">
    <transition-group name="list" tag="div"> 
    <div v-for="(item, idx) in visibleChartDataRows" @click="handleClick(item)" :key="idx" :style="{ height: row_height+'px','margin-bottom':row_gutter+'px' }"
        :class="['a',(idx % 2 == 0? 'new-custom-table-row-odd': 'new-custom-table-row-even'),(item&&select_field&&item[select_field]==1?' new-custom-table-row-active':''),(!isEmpty(item)?'new-custom-table-row-have-content':'')]"
        class="new-custom-table-row" >
        <div class="new-custom-table-row-item " :style="{ width:sort_width+'%'}" v-if="item&&sort_width">
          <div class="flex align-center justify-center" :style="{color:'var(--sort-color,'+calculateThemeColor(item.sort)+')'}"
            style="text-align: center; text-overflow: ellipsis; white-space: nowrap; width: 100%; height: 100%;" >
            <slot v-if="item.sort == 1" name="one"></slot>
            <slot v-else-if="item.sort == 2" name="two"></slot>
            <slot v-else-if="item.sort == 3" name="three"></slot>
            <slot v-else name="other" v-bind:index="item.sort" >{{item.sort }}</slot>
          </div>
        </div>
        <div class="new-custom-table-row-item flex" v-for="(citem, cidx) in chartDataColumns" :key="cidx" v-if="item"
          :style="{ width: ((100 - sort_width) / columns_length * columns_width(citem.prop)) + '%' }">
          <div class="new-custom-table-row-content flex-sub"  style="text-overflow: ellipsis; white-space: nowrap;" :style="calculateColumn(cidx)"
            v-html="item[citem.prop]"></div>
            <div class="progress-container" style="flex: 1;margin: 0px 2px;" v-if="citem.prop == sort_field&&show_progress">
              <div class="progress-bar" :style="{ width: calculateProgress(item[citem.prop]) + '%',background: calculateThemeColor(item.sort)}">
              </div>
            </div>
        </div>
      </div>
    </transition-group>
    </div>
  </div>
</div>
      </div>`,
  name: 'big-screen-custom-table',
  data() {
    return {
      cid:guid(5),
      chartData: null,
      show: false,
      top: 0,
      progressTimer: null,
      chartDataRows: [],
      transkey: 0,
      currentIndex: 0,
      page_size:0,
      visibleChartDataRows: [],
      maxNum:0,
      copyheight: this.height,
      copywidth: this.width,
    }
  },
  props: {
    show_progress: {
      type: Boolean,
      default: true,
    },
    show_header: {
      type: Boolean,
      default: true,
    },
    new_width: {
      type: Boolean,
      default: true,
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    play_type: {
      type: String,
      default: '',
    },
    interval: {
      type: Number,
      default: 5,
    },
    delay: {
      type: Number,
      default: 3,
    },
    height: {
      type: [Number,String],
      default: 400,
    },
    width: {
      type: [Number,String],
      default: 400,
    },
    show_num: {
      type: Number,
      default: 8,
    },
    sort_field: {
      type: String,
      default: '',
    },
    select_field: {
      type: String,
      default: '',
    },
    sort_name: {
      type: String,
      default: '序号',
    },
    sort_width: {
      type: Number,
      default: 10,
    },
    head_height: {
      type: Number,
      default: 40,
    },
    row_gutter: {
      type: Number,
      default: 0,
    },
    theme_color: {
      type: Array,
      default: () =>[],
    },
    column_config: {
      type: Array,
      default: () =>[],
    },
    fieldOptions: {
      type: Object,
      default: () =>{}
    },
    data_source_field_name: {
      type: Object,
      default: () =>{}
    },
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.getHeightAfterUpdate();
          })
        }
      },
      immediate: true,
      deep: true
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.getHeightAfterUpdate();
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    widthStyle(){
      let width = this.width;
      return typeof width == 'number'?width+'px':width
    },
    heightStyle(){
      let height = this.height;
      return typeof height == 'number'?height+'px':height
    },
    chartDataColumns() {
      var columns = this.chartData.table_title || this.chartData.columns
      return columns
    },
    table_body_height(){
     let top = 0;
     let height = this.copyheight;
     if(this.show_header){
      top = this.head_height;
      height = height - this.head_height;
     }
     return {top:top+'px',height:height+'px',show_height:height}
    },
    row_height(){
      return (this.table_body_height.show_height/this.show_num-this.row_gutter)
    },
    columns_length() {
      let length = this.chartDataColumns.length
      return this.show_progress?(length+1):length
    },
    totalRows (){
      return this.chartDataRows.length
    },
    transition(){
      return `all ${this.delay}s ease 0s`
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer)
      this.progressTimer = null
    }
  },
  methods: {
    isEmpty,
    getHeightAfterUpdate() {
      var that = this;
      const div = this.$refs.screen_custom_table; // 获取ref绑定的DOM元素
      Vue.nextTick(() => { // 确保DOM更新完成后再获取高度值
        that.copyheight = div.offsetHeight; // 获取高度（不包括边框）
        that.copywidth = div.offsetWidth;
        that.is_load = true;
        that.renderChart();
      });
    },
    columns_width(prop) {
      return this.show_progress&&prop==this.sort_field?2:1
    },
    calculateProgress(value) {
      let max = this.maxNum;
      value = (value / max) * 100
      return value >100?100:value;
    },
    calculateThemeColor(index) {
      let chartThemeColor = themeColor(this.theme_color);
      let colorIndex = index % chartThemeColor.length;
      return chartThemeColor[colorIndex];
    },
    calculateColumn(index) {
      let column_config = this.column_config||[];
      if(column_config.length<1){return {}}
      let colorIndex = index % column_config.length;
      return {color:column_config[colorIndex].color,"font-size":column_config[colorIndex].size + 'px'}
    },
    handleClick(item) {
      this.$emit('click',item)
    },
    renderChart() {
      if (this.data_source_type == 1) {
        this.chartData = this.fieldOptions
      } else if (this.data_source_type == 2) {
        this.chartData = this.data_source_field_name
      }
      if (!isEmpty(this.chartData)) {
        this.chartDataRows = this.chartData.table_data || this.chartData.rows
        if(isEmpty(this.chartDataRows)){return}
        this.chartDataRows.forEach((item, index) => {
          this.transkey = this.transkey + 1
          item.sort = item.sort|| (index + 1)
          item.key = this.transkey
        })
        let idx = this.sort_order === 'asc'?(this.totalRows - 1):0
        this.maxNum = this.chartDataRows[idx][this.sort_field]
        this.visibleChartDataRows = [...this.chartDataRows]
        if (this.play_type != 'none'&&this.show_num<this.visibleChartDataRows.length) {
          let num = this.show_num - this.totalRows % this.show_num;
          num = num<this.show_num?num:0
          if(this.play_type=='all_num') {
            this.visibleChartDataRows.push(...new Array(num).fill(null),...this.chartDataRows.slice(0,this.show_num))
          }
          this.refresh_Data()
        } else {
          if (this.progressTimer) {
            clearInterval(this.progressTimer)
            this.progressTimer = null
          }
        }
      }
    },
    refresh_Data() {
      var that = this
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      if(that.play_type =="all_num"){
        that.currentIndex = 0;
        that.page_size = (that.visibleChartDataRows.length)/that.show_num;
        setTimeout(() => {
          that.progressTimer = setInterval(function () {
            // console.log(that.currentIndex + 1,that.page_size,'that.page_size')
            if(that.currentIndex + 1>=that.page_size){
              that.currentIndex = 1
              that.$refs['table-body-scroll'+that.cid].style.transition =  "";
              that.$refs['table-body-scroll'+that.cid].style.top =  0;
              setTimeout(() => {
                that.$refs['table-body-scroll'+that.cid].style.top = that.page_height(that.currentIndex);
                that.$refs['table-body-scroll'+that.cid].style.transition =  that.transition;
              },that.delay*1000)
            } else {
              that.currentIndex = that.currentIndex + 1;
              that.$refs['table-body-scroll'+that.cid].style.top = that.page_height(that.currentIndex);  
              that.$refs['table-body-scroll'+that.cid].style.transition =  that.transition;
            }
          }, that.interval*1000)
        })
      } else if(that.play_type =="one_num"){
        setTimeout(() => {
          that.progressTimer = setInterval(function () {
            let data_item = that.visibleChartDataRows.shift()
            that.transkey = that.transkey + 1
            data_item.key = that.transkey
            that.visibleChartDataRows.push(data_item)
          }, that.interval*1000)
        })
      }
    },
    page_height(index){
      return this.play_type =="one_num"?-index*(this.row_height+this.row_gutter)+'px':-index * 100 + '%'
    },
    handleResize() {
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 500)
    }
  },
}
// 水球图
var benbenWaterDroplets = {
  name: 'benben-water-droplets',
  mixins:[mixinsBaseProps,mixinsResize],
  methods: {
    renderChart() {
      this.commonInit();
    },
    commonInit() {
      var sourceData = {}
      this.chart = echarts.init(document.getElementById(this.cId),null, {renderer: 'svg'})
      if (this.data_source_type == '1') {
        sourceData = this.fieldOptions.data
      } else if (this.data_source_type == '2') {
        sourceData = this.data_source_field_name.chart_data.value
      }
      let dataObj = {
        value: sourceData,
      };
      if (this.chartOption.waterSetting.normalColor) {
        dataObj.itemStyle = {
          color: this.chartOption.waterSetting.normalColor
        }
      }
      var option = {
        series: [{
          type: 'liquidFill',
          data: [dataObj],
          ...this.chartOption.waterSetting
        }]
      };
      this.chart.setOption(option)
    },
  },
}
// 全屏按钮
var benbenFullScreen = {
  template: `<div class="benben-full-screen"> 
        <div class="chart-item-content" v-if="!isFullScreen" @click="screen">
          <svg t="1696582031665" class="full-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4278" width="128" height="128"><path d="M240.8 196l178.4 178.4-45.6 45.6-177.6-179.2-68 68V128h180.8l-68 68z m133.6 408.8L196 783.2 128 715.2V896h180.8l-68-68 178.4-178.4-44.8-44.8zM715.2 128l68 68-178.4 178.4 45.6 45.6 178.4-178.4 68 68V128H715.2z m-65.6 476.8l-45.6 45.6 178.4 178.4-68 68H896V715.2l-68 68-178.4-178.4z" p-id="4279"></path></svg>
        </div>
        <div class="chart-item-content" v-if="isFullScreen" @click="exitFullscreen">
          <svg t="1696582021998"  class="full-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4124" width="128" height="128"><path d="M142.4 96.8l-44.8 44.8 173.6 174.4-68 68H384V203.2l-67.2 67.2zM752.8 316l173.6-174.4-44.8-44.8-174.4 173.6-67.2-67.2V384h180.8zM270.4 707.2l-169.6 170.4 44.8 49.6 170.4-174.4 68 68V640H203.2zM820.8 640H640v180.8l68-68 170.4 174.4 44.8-49.6-169.6-170.4z" p-id="4125"></path></svg>
          </div>
        </div>`,
  name: 'benben-full-screen',
  computed: {
    isFullScreen() {
      return vueThis.isFullScreen
    },
  },
  methods: {
    //监听Esc事件；
    screenFull() {
      //监听f11事件
      window.addEventListener("keydown", this.KeyDown, true); 
      document.addEventListener("fullscreenchange", this.initFullscreen);
      document.addEventListener("mozfullscreenchange", this.initFullscreen);
      document.addEventListener("webkitfullscreenchange", this.initFullscreen);
      document.addEventListener("msfullscreenchange", this.initFullscreen);
    },
    KeyDown(event) {
      if (event.keyCode === 122) {
        event.returnValue = false;
        this.isScreenFull(); //触发全屏的方法
      }
    },
    //全屏方法
    isScreenFull() {
      if(!!document.fullscreenElement){
        this.exitFullscreen()
      } else {
        this.screen()
      }
    },
    screen() {
      let elementFull = document.getElementById('antdVue');
      var requestFullScreen = (element) => {
        var requestMethod =
          element.requestFullscreen || //W3C
          element.webkitRequestFullscreen || //Chrome
          element.mozRequestFullScreen || //FireFox
          element.msRequestFullscreen //IE11
        if (requestMethod) {
          requestMethod.call(element)
        } else if (typeof window.ActiveXObject !== 'undefined') {
          //for Internet Explorer
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript !== null) {
            wscript.SendKeys('{F11}')
          }
        }
      }
      requestFullScreen(elementFull) // 整个网页
      vueThis.isFullScreen = true
    },
    exitFullscreen() {
      if (document.exitFullScreen) {//W3C
        document.exitFullScreen()
      }
      //FireFox
      else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      }
      //Chrome等
      else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
      //IE11
      else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
      vueThis.isFullScreen = false
    },
    initFullscreen(){
      vueThis.isFullScreen =!!document.fullscreenElement
    }
  },
  mounted() {
    this.initFullscreen()
    this.screenFull()
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.KeyDown); 
    document.removeEventListener("fullscreenchange",this.initFullscreen);
    document.removeEventListener("mozfullscreenchange",this.initFullscreen);
    document.removeEventListener("webkitfullscreenchange",this.initFullscreen);
    document.removeEventListener("msfullscreenchange",this.initFullscreen);
  },
}
//交互tab
var benbenTab = {
  template: `<div class="switch_tab flex">
  <div v-for="(item,index) in title_list" :key="index" :class="{
    'active': index == activeIndex,'diamond': style_type === 'diamond'
  }" class="item a" @click="tabSelect(item.value)">{{item.name}} </div>
</div>`,
  name: 'benben-tab',
  data() {
    return {
      activeIndex: 0
    }
  },
  props: {
    title_list: {
      type: Array,
      default: []
    },
    style_type: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  watch: {
    value: {
      handler(val) {
        this.activeIndex = val
      },
      immediate: true
    }
  },
  methods: {
    tabSelect(value='') {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },
}
//秋云大屏图表
var mixinsQiuProps = {
  template: `<qiun-vue-ucharts
  :type="type"
  :opts="optsCom"
  :chartData="chartDataCom"
  :disableScroll="true"
  :background="optsCom.background||'transparent'"
  :ontouch="true"/>`,
  components: {
    qiunVueUcharts
  },
  computed: {
    optsCom() { return JSON.parse(JSON.stringify(this.chartOpts)) },
    chartDataCom() { return JSON.parse(JSON.stringify(this.chartDataInfo)) }
  },
  data() {
    return {
      chartOpts: {},
      cId: '',
      chartDataInfo: {},
      chart: null,
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    chart_show_type: {
      type: String,
      default: ''
    },
    data_source_type: {
      type: String,
      default: '1',
    },
    fieldOptions: {
      type: Object,
      default: () =>{},
    },
    data_source_field_name: {
      type: Object,
      default: () =>{},
    },
    theme_color: {
      type: Array,
      default: () =>[],
    },
    chartOption: {
      type: Object,
      default: () =>{
      },
    },
    label_limit:{
      type: Number,
      default: 0,
    }
  },
  watch: {
    fieldOptions: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      immediate: true,
      deep: true,
    },
    data_source_field_name: {
      handler(newValue, oldval) {
        if (!isEmpty(newValue) && newValue != oldval) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
  },
  mounted() {
    function debounce(fn, wait) {
      let timeout = null;
      return function() {
          let context = this, args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function () {
              fn.apply(context, args);
          }, wait);
      };
    }
    var that = this
    window.addEventListener('resize', debounce(function() {
      // 处理窗口大小调整的逻辑
      that.handleResize();
  }, 300));
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.handleResize);
  },
  methods: {
    handleResize() {
      var that = this;
      that.$nextTick(()=>{
        that.renderChart()
      })
    },
    label_limit_func(label_limit,categories){
       return categories.map((value)=>{
          return  value.length>label_limit ?value.slice(0,label_limit):value;
        })
    }
  }
}
//折线图
var qiuLineCharts = {
  name: 'qiu-line-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      if (this.chart_show_type == "line-gradient-curve" || this.chart_show_type == "line-gradient-shadow") {
        // 渐变色曲线图
        var seriesList = []
        if (this.chartDataInfo && this.chartDataInfo.series.length) {
          var themeColorList = this.chartOption.color;
          for (var index = 0; index < this.chartDataInfo.series.length; index++) {
            var obj = { ...this.chartDataInfo.series[index] }
            var morColor = vueThis.adjustColorOpacity(themeColorList[index % themeColorList.length], 0.8)
            var linearColor = [[0, themeColorList[index % themeColorList.length]], [1, morColor]]
            obj.linearColor = linearColor;
            if (this.chart_show_type == "line-gradient-shadow") {
              // 渐变色+阴影+水平动画
              obj.setShadow = [3, 8, 10, themeColorList[index % themeColorList.length]]
            }
            seriesList.push(obj)
          }
          this.chartDataInfo.series = seriesList;
        }
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//柱状图  qiu-column-charts
var qiuColumnCharts = {
  name: 'qiu-column-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      
      if (that.chart_show_type == 'column_positive_negative'&&this.chartDataInfo.peak) {
        var peak = this.chartDataInfo.peak
        peak.min = peak.min <0?peak.min:0
        that.chartOption.yAxis.data = [peak]
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//条状图 qiu-bar-charts
var qiuBarCharts = {
  name: 'qiu-bar-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//区域图 qiu-area-charts
var qiuAreaCharts = {
  name: 'qiu-area-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//饼状图 qiu-pie-charts
var qiuPieCharts = {
  name: 'qiu-pie-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//玫瑰图 qiu-rose-charts
var qiuRoseCharts = {
  name: 'qiu-rose-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//进度条 qiu-arcbar-charts
var qiuArcbarCharts = {
  name: 'qiu-arcbar-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//漏斗图 qiu-funnel-charts
var qiuFunnelCharts = {
  name: 'qiu-funnel-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//山峰图 qiu-mount-charts
var qiuMountCharts = {
  name: 'qiu-mount-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//环形图 qiu-ring-charts
var qiuRingCharts = {
  name: 'qiu-ring-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//雷达图 qiu-radar-charts
var qiuRadarCharts = {
  name: 'qiu-radar-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//仪表盘 qiu-gauge-charts
var qiuGaugeCharts = {
  name: 'qiu-gauge-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      this.chartDataInfo.categories = this.chartOption.categories
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//词云图 qiu-word-charts
var qiuWordCharts = {
  name: 'qiu-word-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//K线图 qiu-candle-charts
var qiuCandleCharts = {
  name: 'qiu-candle-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//气泡图 qiu-bubble-charts
var qiuBubbleCharts = {
  name: 'qiu-bubble-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//散点图 qiu-scatter-charts
var qiuScatterCharts = {
  name: 'qiu-scatter-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
//混合图 qiu-mix-charts
var qiuMixCharts = {
  name: 'qiu-mix-charts',
  mixins:[mixinsQiuProps],
  methods: {
    renderChart() {
      var that = this
      if (this.data_source_type == '1') {
        this.chartDataInfo = this.fieldOptions
      } else if (this.data_source_type == '2') {
        this.chartDataInfo = this.data_source_field_name
      }
      if(this.label_limit&&this.label_limit>0){
        this.chartDataInfo.categories = this.label_limit_func(this.label_limit,this.chartDataInfo.categories)
      }
      if(!isEmpty(this.chartDataInfo)&&!isEmpty(this.chartDataInfo.series)){
        setTimeout(() => {
          that.chartOpts = {
            animation: true,
            padding: [15, 25, 0, 5],
            ...that.chartOption,
            color: themeColor(this.theme_color,2),
          }
        }, 500);
      }
    },
  },
}
// 地图 qiu-map-charts
var qiuMapCharts = {
  name: 'qiu-map-charts',
  mixins:[mixinsQiuProps],
  data() {
    return {
    }
  },
  props: {
    fill_color: {
      type: Array,
      default: ["#50a3ba","#7cada1","#a8b888","#e8b662","#e39360","#de715f","#d94e5d"],
    },
  },
  methods: {
    renderChart() {
        var that = this
        if (this.data_source_type == '1'||this.data_source_type == '2') {
          var that = this
          that.chartDataInfo = { series: mapdata.features }
          setTimeout(() => {
            that.chartOpts = {
              animation: true,
              padding: [15, 25, 0, 5],
              ...that.chartOption,
              color: themeColor(this.theme_color,2),
            }
          }, 500);
        }
    }
  },
}
const bigScreenMixins = {
  components: {
    qiuLineCharts, qiuColumnCharts, qiuBarCharts,qiuAreaCharts,qiuPieCharts,
    qiuRoseCharts,qiuArcbarCharts, qiuFunnelCharts,qiuMountCharts,qiuRingCharts,
    qiuRadarCharts, qiuGaugeCharts, qiuWordCharts,qiuCandleCharts,qiuBubbleCharts,
    qiuScatterCharts, qiuMixCharts,qiuMapCharts,
    benbenWaterDroplets,benbenTab,benbenFullScreen,benbenNumberBlock,benbenNumberFlipper,
    bigScreenTable, bigScreenRank,bigScreenCustomTable,benbenSimpleText,benbenLightText,
    benbenSingleLightText, benbenNumberCard, benbenCountDown,benbenRealTime,
    benbenThreeDimensionalPie,benbenThreeDimensionalRing,benbenThreeDimensionalBar,benbenCubeBar,
    benbenThreeBarBackground,benbenThreeDimensionalSpaceRing,benbenThreeDimensionalPieThree,
    benbenThreeDimensionalFunnel, wordCloud, benbenThreeDimensionalPieTwo, benbenGlobleLineMap,
    benbenChinaMap,benbenOtherRadar,benbenOtherFunnel,benbenOtherDashboard,benbenPieBase,
    benbenPieRing, benbenPieCircularRing,benbenPieCircular, benbenPieNestedRing,benbenPieProgress,
    benbenPieRose,benbenBarAccumul, benbenBarMultiSeries, benbenBarPlusMinus,benbenBarBackground,
    benbenBarCross,benbenBarBase,benbenBarPictorial,benbenBarPictorialCross,benbenLineAreaAccumul, benbenLineDoubleY,
    benbenLineFold,benbenLineMatchBar,benbenLineSimple,benbenAreaMap, benbenRelationGraph,benbenRotateRing
  },
  data() {
    return {
      global_time: { rangeType: 5, rangeValue: '' },
      loadNum: 0, //
    }
  },
  watch: {
    global_time: {
      handler(newValue, oldval) {
        if(newValue){
          this.chart_get_page()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
  created() {
    sessionStorage.removeItem('screen_global_time_count_time')
  },
  mounted() { 
  },
  methods: {
    adjustColorOpacity(color, opacity) {
      if (color.startsWith('#')) {
        // 十六进制颜色值
        return this.adjustHexColorOpacity(color, opacity);
      } else if (color.toLowerCase().startsWith('rgb(')) {
        // RGB颜色值
        return this.adjustRGBColorOpacity(color, opacity);
      } else {
        // 无法识别的格式，返回原始颜色
        return color;
      }
    },
    adjustHexColorOpacity(hexColor, opacity) {
      // 将十六进制颜色转换为RGB
      var r = parseInt(hexColor.substring(1, 3), 16);
      var g = parseInt(hexColor.substring(3, 5), 16);
      var b = parseInt(hexColor.substring(5, 7), 16);
      // 将RGB转换为HSL
      var hsl = this.rgbToHsl(r, g, b);
      // 调整透明度
      hsl[2] = opacity * 100; // 将亮度调整为透明度的百分比
      // 将HSL转换回RGB
      var rgb = this.hslToRgb(hsl[0], hsl[1], hsl[2]);
      // 将RGB转换为十六进制颜色
      var newHexColor = this.rgbToHex(rgb[0], rgb[1], rgb[2]);
      return newHexColor;
    },
    adjustRGBColorOpacity(rgbColor, opacity) {
      // 处理RGB颜色
      // 提取RGB值
      var values = rgbColor.match(/\d+/g);
      if (!values || values.length !== 3) {
        return rgbColor;
      }
      var r = parseInt(values[0]);
      var g = parseInt(values[1]);
      var b = parseInt(values[2]);
      // 使用之前提供的 adjustColorOpacityRGB 函数
      var adjustedRGB = this.adjustColorOpacityRGB(r, g, b, opacity);
      // 返回调整后的RGB格式字符串
      return rgbToHex(adjustedRGB[0], adjustedRGB[1], adjustedRGB[2]);
    },
    adjustColorOpacityRGB(r, g, b, opacity) {
      // 将RGB转换为HSL
      var hsl = this.rgbToHsl(r, g, b);
      // 调整透明度
      hsl[2] = opacity * 100; // 将亮度调整为透明度的百分比
      // 将HSL转换回RGB
      var rgb = this.hslToRgb(hsl[0], hsl[1], hsl[2]);
      return rgb;
    },
    // 将RGB转换为HSL
    rgbToHsl(r, g, b) {
      r /= 255;
      g /= 255;
      b /= 255;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h, s, l = (max + min) / 2;
      if (max === min) {
        h = s = 0;
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r: h = (g - b) / d + (g < b ? 6 : 0); break;
          case g: h = (b - r) / d + 2; break;
          case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
      }
      return [h * 360, s * 100, l * 100];
    },
    // 将HSL转换为RGB
    hslToRgb(h, s, l) {
      h /= 360;
      s /= 100;
      l /= 100;
      var r, g, b;
      if (s === 0) {
        r = g = b = l;
      } else {
        var hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    },
    // 将RGB转换为十六进制颜色
    rgbToHex(r, g, b) {
      return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
    },
    chart_get_page() {
      this.get_diy_api_page()
    },
    get_diy_api_page() {
    },
  },
}
export {
  bigScreenMixins
}
